/* eslint-disable max-len */
export const LOGO_SVG = ({ color = '#2C2A6E', height = 181, width = 400 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 400 181"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M267.027 113.32C266.616 115.931 266.264 118.673 265.958 121.545C265.653 124.417 265.5 126.114 265.5 126.636C263.056 136.036 259.795 145.089 255.723 153.79C249.812 166.675 244.618 173.113 240.141 173.113C235.657 173.113 233.419 164.672 233.419 147.786C233.419 139.781 235.757 128.553 240.446 114.104C246.351 96.8708 252.562 88.2538 259.084 88.2538C265.194 88.2538 268.25 92.1703 268.25 100.003C268.25 104.01 267.839 108.448 267.027 113.32ZM92.88 148.829C92.88 130.552 96.646 111.753 104.184 92.4316C104.996 90.1716 106.218 89.0377 107.851 89.0377C110.701 89.0377 112.128 91.9989 112.128 97.9142C112.128 104.704 110.19 113.842 106.323 125.33C102.046 138.561 97.5633 146.394 92.88 148.829ZM397.184 99.7427C395.756 99.7427 394.535 101.048 393.517 103.659C388.629 119.153 384.963 130.642 382.519 138.124C376.203 156.578 370.297 165.801 364.797 165.801C358.887 165.801 355.937 157.536 355.937 140.996C355.937 135.252 356.748 127.248 358.381 116.976C360.415 105.838 361.436 99.31 361.436 97.3928C361.637 96.3482 362.301 94.6101 363.422 92.1703C364.539 89.7347 365.103 88.2538 365.103 87.7324C365.103 84.9491 362.147 83.5539 356.243 83.5539C352.776 83.2069 350.742 85.2961 350.132 89.8204L350.437 99.7427C350.437 101.66 349.926 105.401 348.909 110.97C347.482 118.281 346.771 122.026 346.771 122.197C344.527 135.774 341.165 147.092 336.688 156.141C335.666 158.405 333.938 161.8 331.494 166.324C328.845 170.676 325.994 172.852 322.939 172.852C319.067 172.852 317.134 169.024 317.134 161.363C317.134 143.085 318.557 126.897 321.411 112.798C321.817 111.582 322.428 109.579 323.244 106.792C324.056 104.532 324.466 102.529 324.466 100.787C324.466 99.0493 323.65 97.4377 322.022 95.9562C320.39 94.4801 318.557 93.7369 316.523 93.7369C314.078 93.7369 312.346 94.4345 311.328 95.8262C310.701 96.6686 310.133 99.0404 309.624 102.937C309.262 103.731 308.912 104.658 308.58 105.747C304.503 120.023 300.226 132.902 295.748 144.391C289.027 161.975 283.832 170.763 280.166 170.763C275.888 170.069 273.544 163.541 273.138 151.18C273.138 145.787 274.867 131.25 278.333 107.576C282.81 77.8101 285.255 61.4498 285.665 58.488C287.498 50.3079 289.637 40.6025 292.081 29.3749C294.526 18.1479 296.154 10.9674 296.97 7.83419C297.782 2.61174 295.748 0.00109863 290.86 0.00109863C288.21 0.00109863 286.477 0.0909583 285.665 0.2624C283.221 0.959397 282.304 3.65635 282.916 8.3568C281.283 19.3225 279.145 33.1206 276.498 49.7415C273.849 66.366 272.117 77.463 271.305 83.0319C270.894 83.5539 270.488 83.8158 270.083 83.8158C269.877 83.8158 267.839 82.5992 263.972 80.16C260.306 77.5487 257.145 76.2434 254.501 76.2434C246.757 76.2434 239.324 86.08 232.196 105.747C229.356 113.736 227.161 121.334 225.598 128.547C224.353 132.171 222.999 135.958 221.506 139.953C214.579 158.405 208.674 167.629 203.785 167.629C198.08 167.629 195.23 158.23 195.23 139.43C195.23 133.686 196.247 122.634 198.286 106.27C199.097 100.178 199.708 95.5655 200.119 92.4316C200.452 90.5452 200.731 89.2529 200.955 88.5304C199.241 85.2825 194.287 83.4451 186.064 83.0319C183.821 84.4277 182.397 88.7758 181.787 96.0869C180.97 106.882 177.509 120.37 171.398 136.558C169.971 139.691 167.832 146.309 164.982 156.402C163.349 160.93 162.027 163.19 161.01 163.19C157.75 163.19 156.121 156.924 156.121 144.391C156.121 139.169 156.222 134.469 156.427 130.291C156.627 126.114 156.733 121.413 156.733 116.192C156.733 113.932 157.343 111.145 158.566 107.837C159.988 104.357 160.704 102.093 160.704 101.048C160.704 97.9142 158.666 96.3482 154.594 96.3482C150.722 96.3482 148.177 97.7433 146.955 100.525C146.368 101.653 145.942 103.605 145.672 106.353C144.902 108.561 144.009 111.31 142.988 114.625C130.767 154.313 119.766 174.157 109.99 174.157C106.523 174.157 103.062 172.329 99.6013 168.674C96.1348 164.847 94.4074 161.453 94.4074 158.491C99.4968 151.702 103.773 145.003 107.239 138.386C115.995 122.372 120.378 107.927 120.378 95.0423C120.378 91.387 118.593 88.2538 115.031 85.6431C111.465 83.0319 107.441 81.7266 102.962 81.7266C95.6298 81.7266 90.0243 91.2162 86.1573 110.187C85.635 112.663 85.1784 115.109 84.7592 117.538C75.4596 149.71 67.0683 165.801 59.5791 165.801C54.6909 165.801 51.836 160.494 51.0245 149.874C50.6143 144.652 50.413 134.906 50.413 120.631C50.413 107.053 52.8577 85.6431 57.7458 56.4L72.4123 56.6607C78.9288 56.8357 87.8888 56.9214 99.299 56.9214C103.166 56.9214 108.971 56.3137 116.715 55.0941C126.081 53.703 131.176 52.5727 131.992 51.6995V49.8722C126.491 49.7008 120.582 49.5695 114.271 49.4802C107.955 49.3945 102.76 49.2639 98.6882 49.0883C94.6115 48.9169 91.4556 48.8276 89.217 48.8276C84.7343 48.8276 80.2031 48.7868 75.6201 48.6969C71.037 48.6106 67.5719 48.5261 65.2323 48.4356C62.8878 48.3499 61.2075 48.305 60.1906 48.305C61.819 41.5165 63.0401 36.2083 63.857 32.3775V26.8949C58.3581 23.7617 54.28 22.1945 51.6353 22.1945C50.0034 22.1945 48.8855 22.8063 48.2747 24.023L49.8021 28.7222C49.5974 32.2066 49.0861 38.6446 48.2747 48.0437C23.4259 48.9169 8.55475 49.3496 3.66663 49.3496C1.22188 49.3496 -0.000488281 49.9615 -0.000488281 51.1775C-0.000488281 52.2215 1.12159 53.1804 3.36157 54.0495C6.21586 55.0941 8.35414 56.3137 9.77713 57.7053L16.8042 55.8768C33.9147 56.053 44.198 56.3137 47.6638 56.6607C42.3648 100.003 39.7194 125.33 39.7194 132.642C39.7194 140.65 40.8374 148.745 43.0808 156.924C46.5425 168.763 51.7357 174.679 58.6631 174.679C66.0666 174.679 73.91 164.773 82.2003 144.964C82.1982 145.294 82.1858 145.629 82.1858 145.957C82.1858 153.79 84.2196 161.191 88.2969 168.151C93.5911 176.336 100.518 180.424 109.072 180.424C115.183 180.424 120.578 177.897 125.266 172.852C132.55 164.267 139.933 147.626 147.414 122.929L147.261 124.547C146.65 130.814 146.65 137.778 147.261 145.436L148.483 165.019C150.111 172.329 153.983 175.984 160.094 175.984C164.371 175.984 167.526 172.244 169.565 164.757C176.286 141.955 181.581 124.898 185.453 113.58C186.675 137.256 187.998 152.224 189.425 158.491C192.276 170.852 197.469 177.029 205.007 177.029C209.693 177.029 215.601 169.075 222.726 153.182C222.726 153.211 222.724 153.24 222.724 153.269C222.724 160.058 224.053 165.801 226.697 170.501C230.158 177.115 235.046 180.424 241.362 180.424C246.252 180.424 251.14 176.507 256.028 168.674C257.861 165.891 260.812 160.233 264.889 151.702C266.722 168.935 272.422 177.551 281.999 177.551C287.293 177.551 294.421 166.152 303.387 143.347C304.928 139.327 306.315 135.599 307.557 132.143C307.018 141.779 306.745 150.227 306.745 157.446C306.745 162.497 307.967 167.197 310.412 171.546C313.467 176.768 317.64 179.379 322.939 179.379C328.845 179.379 333.633 176.682 337.298 171.285C338.316 169.196 339.897 165.977 342.035 161.624C344.173 157.274 345.748 154.052 346.771 151.963C349.62 159.971 351.453 164.495 352.27 165.54C355.526 171.285 359.398 174.157 363.881 174.157C372.23 174.157 380.685 162.582 389.24 139.43C396.162 121.153 399.628 108.97 399.628 102.875C399.628 100.787 398.811 99.7427 397.184 99.7427Z"
      fill={color}
    />
  </svg>
);

export const GOOGLE_SVG = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4890_19221)">
      <path
        d="M39.5 20C39.5 9.23045 30.7696 0.5 20 0.5C9.23045 0.5 0.5 9.23045 0.5 20C0.5 30.7696 9.23045 39.5 20 39.5C30.7696 39.5 39.5 30.7696 39.5 20Z"
        fill="white"
      />
      <mask
        id="mask0_4890_19221"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="10"
        y="10"
        width="20"
        height="20"
      >
        <path
          d="M30 10H10V30H30V10Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_4890_19221)">
        <path
          d="M29.6 20.2271C29.6 19.518 29.5364 18.8362 29.4182 18.1816H20V22.0498H25.3818C25.15 23.2998 24.4455 24.3589 23.3864 25.068V27.5771H26.6182C28.5091 25.8362 29.6 23.2725 29.6 20.2271Z"
          fill="#4285F4"
        />
        <path
          d="M20 29.9999C22.7 29.9999 24.9636 29.1044 26.6181 27.5772L23.3863 25.0681C22.4909 25.6681 21.3454 26.0226 20 26.0226C17.3954 26.0226 15.1909 24.2635 14.4045 21.8999H11.0636V24.4908C12.7091 27.759 16.0909 29.9999 20 29.9999Z"
          fill="#34A853"
        />
        <path
          d="M14.4045 21.9002C14.2045 21.3002 14.0909 20.6593 14.0909 20.0002C14.0909 19.3411 14.2045 18.7002 14.4045 18.1002V15.5093H11.0636C10.3864 16.8593 10 18.3866 10 20.0002C10 21.6138 10.3864 23.1411 11.0636 24.4911L14.4045 21.9002Z"
          fill="#FBBC04"
        />
        <path
          d="M20 13.9773C21.4681 13.9773 22.7863 14.4818 23.8227 15.4727L26.6909 12.6045C24.9591 10.9909 22.6954 10 20 10C16.0909 10 12.7091 12.2409 11.0636 15.5091L14.4045 18.1C15.1909 15.7364 17.3954 13.9773 20 13.9773Z"
          fill="#E94235"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_4890_19221">
        <rect
          width="40"
          height="40"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);

export const APPLE_SVG = () => (
  <svg
    width="40"
    height="41"
    viewBox="0 0 40 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M39.5 20.5C39.5 9.73045 30.7696 1 20 1C9.23045 1 0.5 9.73045 0.5 20.5C0.5 31.2696 9.23045 40 20 40C30.7696 40 39.5 31.2696 39.5 20.5Z"
      fill="white"
    />
    <path
      d="M23.0767 13.6979C22.4062 14.5103 21.2714 15.1164 20.3688 15.1164C20.2656 15.1164 20.1625 15.1035 20.098 15.0906C20.0851 15.039 20.0593 14.8843 20.0593 14.7295C20.0593 13.6979 20.588 12.6663 21.1554 12.0216C21.8775 11.1705 23.0896 10.5387 24.0954 10.5C24.1212 10.6161 24.1341 10.7579 24.1341 10.8997C24.1341 11.9313 23.6957 12.95 23.0767 13.6979ZM23.7859 15.3356C24.3533 15.3356 26.4036 15.3872 27.7447 17.3214C27.6286 17.4117 25.5912 18.5593 25.5912 21.1254C25.5912 24.0912 28.1831 25.1486 28.2605 25.1744C28.2476 25.2389 27.8478 26.6057 26.8936 28.0113C26.0426 29.2363 25.1399 30.4742 23.7859 30.4742C22.4191 30.4742 22.0709 29.6747 20.5106 29.6747C18.9761 29.6747 18.4346 30.5 17.1966 30.5C15.9458 30.5 15.0819 29.3524 14.089 27.9597C12.9284 26.3092 12 23.756 12 21.3317C12 17.4504 14.5274 15.3872 17.0161 15.3872C18.3314 15.3872 19.4275 16.2511 20.2656 16.2511C21.0522 16.2511 22.2772 15.3356 23.7859 15.3356Z"
      fill="black"
    />
  </svg>
);

export const INSTAGRAM_SVG = () => (
  <svg
    width="40"
    height="41"
    viewBox="0 0 40 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M39.5 20.5C39.5 9.73045 30.7696 1 20 1C9.23045 1 0.5 9.73045 0.5 20.5C0.5 31.2696 9.23045 40 20 40C30.7696 40 39.5 31.2696 39.5 20.5Z"
      fill="white"
    />
    <path
      d="M26.5386 15.1624C26.5386 14.4977 25.9999 13.961 25.3377 13.961C24.6754 13.961 24.1362 14.4977 24.1362 15.1624C24.1362 15.8246 24.6754 16.3613 25.3377 16.3613C25.9999 16.3613 26.5386 15.8246 26.5386 15.1624Z"
      fill="url(#paint0_linear_4895_19626)"
    />
    <path
      d="M28.1388 24.5404C28.0943 25.5154 27.9312 26.0452 27.7958 26.3971C27.614 26.8636 27.397 27.1972 27.0451 27.5471C26.6972 27.897 26.3636 28.1135 25.8971 28.2933C25.5452 28.4308 25.0134 28.5943 24.0384 28.6408C22.9843 28.6872 22.6719 28.6971 19.9988 28.6971C17.3281 28.6971 17.0133 28.6872 15.9591 28.6408C14.9841 28.5943 14.4548 28.4308 14.1029 28.2933C13.6339 28.1135 13.3028 27.897 12.9529 27.5471C12.6005 27.1972 12.3836 26.8636 12.2042 26.3971C12.0687 26.0452 11.9032 25.5154 11.8612 24.5404C11.8098 23.4862 11.8004 23.1689 11.8004 20.5012C11.8004 17.8281 11.8098 17.5133 11.8612 16.4591C11.9032 15.4841 12.0687 14.9548 12.2042 14.5999C12.3836 14.1339 12.6005 13.8023 12.9529 13.4524C13.3028 13.103 13.6339 12.886 14.1029 12.7042C14.4548 12.5663 14.9841 12.4052 15.9591 12.3587C17.0133 12.3122 17.3281 12.3004 19.9988 12.3004C22.6719 12.3004 22.9843 12.3122 24.0384 12.3587C25.0134 12.4052 25.5452 12.5663 25.8971 12.7042C26.3636 12.886 26.6972 13.103 27.0451 13.4524C27.397 13.8023 27.614 14.1339 27.7958 14.5999C27.9312 14.9548 28.0943 15.4841 28.1388 16.4591C28.1877 17.5133 28.1996 17.8281 28.1996 20.5012C28.1996 23.1689 28.1877 23.4862 28.1388 24.5404ZM29.9392 16.3771C29.8903 15.3116 29.7222 14.5836 29.4727 13.9496C29.2187 13.2918 28.8781 12.7343 28.3207 12.1768C27.7657 11.6219 27.2082 11.2813 26.5504 11.0244C25.9139 10.7773 25.1884 10.6072 24.1224 10.5608C23.0564 10.5094 22.7159 10.5 19.9988 10.5C17.2841 10.5 16.9411 10.5094 15.8751 10.5608C14.8116 10.6072 14.0866 10.7773 13.4471 11.0244C12.7918 11.2813 12.2343 11.6219 11.6793 12.1768C11.1219 12.7343 10.7813 13.2918 10.5248 13.9496C10.2777 14.5836 10.1097 15.3116 10.0583 16.3771C10.0119 17.4431 10 17.7841 10 20.5012C10 23.2159 10.0119 23.5564 10.0583 24.6224C10.1097 25.6859 10.2777 26.4134 10.5248 27.0504C10.7813 27.7058 11.1219 28.2657 11.6793 28.8207C12.2343 29.3757 12.7918 29.7187 13.4471 29.9752C14.0866 30.2222 14.8116 30.3903 15.8751 30.4392C16.9411 30.4881 17.2841 30.5 19.9988 30.5C22.7159 30.5 23.0564 30.4881 24.1224 30.4392C25.1884 30.3903 25.9139 30.2222 26.5504 29.9752C27.2082 29.7187 27.7657 29.3757 28.3207 28.8207C28.8781 28.2657 29.2187 27.7058 29.4727 27.0504C29.7222 26.4134 29.8903 25.6859 29.9392 24.6224C29.9881 23.5564 30 23.2159 30 20.5012C30 17.7841 29.9881 17.4431 29.9392 16.3771Z"
      fill="url(#paint1_linear_4895_19626)"
    />
    <path
      d="M19.9988 23.8319C18.1588 23.8319 16.6659 22.3414 16.6659 20.5014C16.6659 18.6585 18.1588 17.1661 19.9988 17.1661C21.8392 17.1661 23.3342 18.6585 23.3342 20.5014C23.3342 22.3414 21.8392 23.8319 19.9988 23.8319ZM19.9988 15.3632C17.1625 15.3632 14.8655 17.6652 14.8655 20.5014C14.8655 23.3352 17.1625 25.6348 19.9988 25.6348C22.835 25.6348 25.1346 23.3352 25.1346 20.5014C25.1346 17.6652 22.835 15.3632 19.9988 15.3632Z"
      fill="url(#paint2_linear_4895_19626)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4895_19626"
        x1="10.1804"
        y1="30.2932"
        x2="28.3342"
        y2="12.1395"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFD521" />
        <stop
          offset="0.05"
          stopColor="#FFD521"
        />
        <stop
          offset="0.501119"
          stopColor="#F50000"
        />
        <stop
          offset="0.95"
          stopColor="#B900B4"
        />
        <stop
          offset="0.950079"
          stopColor="#B900B4"
        />
        <stop
          offset="1"
          stopColor="#B900B4"
        />
      </linearGradient>
      <linearGradient
        id="paint1_linear_4895_19626"
        x1="10.1804"
        y1="30.3181"
        x2="28.3491"
        y2="12.1494"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFD521" />
        <stop
          offset="0.05"
          stopColor="#FFD521"
        />
        <stop
          offset="0.501119"
          stopColor="#F50000"
        />
        <stop
          offset="0.95"
          stopColor="#B900B4"
        />
        <stop
          offset="0.950079"
          stopColor="#B900B4"
        />
        <stop
          offset="1"
          stopColor="#B900B4"
        />
      </linearGradient>
      <linearGradient
        id="paint2_linear_4895_19626"
        x1="10.1851"
        y1="30.3188"
        x2="28.3495"
        y2="12.1545"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFD521" />
        <stop
          offset="0.05"
          stopColor="#FFD521"
        />
        <stop
          offset="0.501119"
          stopColor="#F50000"
        />
        <stop
          offset="0.95"
          stopColor="#B900B4"
        />
        <stop
          offset="0.950079"
          stopColor="#B900B4"
        />
        <stop
          offset="1"
          stopColor="#B900B4"
        />
      </linearGradient>
    </defs>
  </svg>
);

export const CLOSED_EYE_SVG = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4603_12643)">
      <path
        d="M20.1744 19.6744L4.82467 4.32522L4.82139 4.32147C4.73829 4.23904 4.63977 4.17379 4.53145 4.12945C4.42313 4.0851 4.30714 4.06252 4.19009 4.063C4.07305 4.06347 3.95724 4.087 3.84929 4.13224C3.74134 4.17747 3.64335 4.24352 3.56092 4.32663C3.4785 4.40973 3.41325 4.50825 3.3689 4.61657C3.32455 4.72489 3.30197 4.84088 3.30245 4.95793C3.30342 5.19431 3.39825 5.42063 3.56608 5.58709L4.90999 6.931C3.28019 8.04721 1.87735 9.46295 0.776081 11.1029C0.596244 11.3684 0.500122 11.6817 0.500122 12.0024C0.500122 12.3231 0.596244 12.6364 0.776081 12.9019C3.58717 17.0626 8.04358 19.5001 12.5 19.4696C13.9435 19.4748 15.3774 19.2345 16.7403 18.759L18.9158 20.9344C19.0834 21.0966 19.3079 21.1866 19.5412 21.185C19.7744 21.1834 19.9977 21.0904 20.1631 20.9259C20.3285 20.7615 20.4228 20.5387 20.4257 20.3055C20.4286 20.0722 20.3398 19.8472 20.1786 19.6787L20.1744 19.6744ZM12.5 17.0504C11.6557 17.0501 10.8249 16.8382 10.0836 16.434C9.34228 16.0299 8.71407 15.4464 8.25638 14.7369C7.79869 14.0274 7.52611 13.2145 7.46355 12.3725C7.40099 11.5305 7.55045 10.6863 7.89827 9.91694L9.30217 11.3208C9.18909 11.8537 9.21094 12.4064 9.36574 12.9287C9.52054 13.451 9.80338 13.9263 10.1886 14.3115C10.5738 14.6967 11.0491 14.9795 11.5714 15.1343C12.0937 15.2891 12.6463 15.311 13.1792 15.1979L14.5831 16.6018C13.9288 16.8985 13.2184 17.0514 12.5 17.0504Z"
        fill="#C1BECF"
      />
      <path
        d="M24.2239 11.1006C21.4128 6.93759 16.9564 4.50009 12.5 4.53056C11.0565 4.52533 9.62257 4.76563 8.25964 5.24118L10.4159 7.39743C11.3516 6.974 12.394 6.84578 13.4044 7.02987C14.4148 7.21395 15.3451 7.70159 16.0713 8.4278C16.7975 9.15401 17.2852 10.0843 17.4692 11.0947C17.6533 12.1051 17.5251 13.1475 17.1017 14.0832L20.0895 17.071C21.7196 15.955 23.1226 14.5392 24.2239 12.8991C24.4036 12.6337 24.4997 12.3204 24.4997 11.9999C24.4997 11.6793 24.4036 11.366 24.2239 11.1006Z"
        fill="#C1BECF"
      />
      <path
        d="M12.5 8.73096C12.2717 8.73099 12.0441 8.75487 11.8208 8.80221L15.6978 12.6788C15.7989 12.2025 15.7924 11.7096 15.6786 11.2362C15.5648 10.7628 15.3467 10.3207 15.0403 9.94237C14.7338 9.56401 14.3467 9.2589 13.9072 9.04931C13.4677 8.83973 12.9869 8.73096 12.5 8.73096Z"
        fill="#C1BECF"
      />
    </g>
    <defs>
      <clipPath id="clip0_4603_12643">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const EYE_SVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 15.6969C14.0406 15.6969 15.6949 14.0427 15.6949 12.0021C15.6949 9.96145 14.0406 8.30721 12 8.30721C9.95941 8.30721 8.30518 9.96145 8.30518 12.0021C8.30518 14.0427 9.95941 15.6969 12 15.6969Z"
      fill="#C1BECF"
    />
    <path
      d="M23.6319 10.9786C20.7917 7.54653 16.4926 4.24288 12 4.24288C7.50665 4.24288 3.20646 7.54884 0.368214 10.9786C-0.122738 11.5716 -0.122738 12.4325 0.368214 13.0255C1.08178 13.8878 2.57773 15.5523 4.57572 17.0067C9.60759 20.6698 14.3814 20.6779 19.4244 17.0067C21.4224 15.5523 22.9183 13.8878 23.6319 13.0255C24.1214 12.4337 24.1239 11.5735 23.6319 10.9786ZM12 6.82927C14.8525 6.82927 17.1728 9.14964 17.1728 12.0021C17.1728 14.8545 14.8525 17.1748 12 17.1748C9.14763 17.1748 6.82726 14.8545 6.82726 12.0021C6.82726 9.14964 9.14763 6.82927 12 6.82927Z"
      fill="#C1BECF"
    />
  </svg>
);

export const SIDE_ARROW_SVG = ({ direction = 'right' }) => {
  const directions = {
    right: 0,
    left: 180,
    up: 270,
    down: 90,
  };

  const degree = directions[direction];

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: `rotate(${degree}deg)` }}
    >
      <path
        d="M17.2421 5.99219C17.0929 5.99222 16.947 6.03679 16.8232 6.12019C16.6994 6.20358 16.6033 6.32202 16.5472 6.46033C16.4911 6.59865 16.4776 6.75056 16.5083 6.89662C16.539 7.04269 16.6126 7.17627 16.7197 7.28027L20.4394 11H1.74994C1.65056 10.9986 1.55188 11.017 1.45966 11.054C1.36743 11.0911 1.28349 11.1461 1.21271 11.2159C1.14194 11.2857 1.08573 11.3688 1.04737 11.4605C1.00901 11.5522 0.989258 11.6506 0.989258 11.75C0.989258 11.8494 1.00901 11.9478 1.04737 12.0395C1.08573 12.1312 1.14194 12.2143 1.21271 12.2841C1.28349 12.3539 1.36743 12.4089 1.45966 12.446C1.55188 12.483 1.65056 12.5014 1.74994 12.5H20.4394L16.7197 16.2197C16.6477 16.2888 16.5902 16.3716 16.5506 16.4632C16.511 16.5548 16.4901 16.6534 16.4891 16.7532C16.4881 16.8529 16.507 16.9519 16.5447 17.0443C16.5824 17.1367 16.6382 17.2206 16.7088 17.2912C16.7793 17.3617 16.8633 17.4175 16.9556 17.4552C17.048 17.4929 17.147 17.5118 17.2468 17.5108C17.3466 17.5098 17.4451 17.4889 17.5367 17.4493C17.6283 17.4097 17.7111 17.3523 17.7802 17.2803L22.7802 12.2803C22.9208 12.1396 22.9998 11.9489 22.9998 11.75C22.9998 11.5511 22.9208 11.3604 22.7802 11.2197L17.7802 6.21973C17.7103 6.14773 17.6267 6.0905 17.5342 6.05142C17.4418 6.01233 17.3425 5.99219 17.2421 5.99219Z"
        fill="#250473"
      />
    </svg>
  );
};

export const PAGINATION_ARROW_SVG = ({ isRight }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ transform: `rotate(${isRight ? 180 : 0}deg)` }}
  >
    <path
      d="M15.8333 10.0003H4.16663M4.16663 10.0003L9.99996 15.8337M4.16663 10.0003L9.99996 4.16699"
      stroke="#344054"
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DROPDOWN_CHEVRON_SVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 9L12 15L6 9"
      stroke="#090A14"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UPLOAD_SVG = ({ size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.4175 13.5664C19.2631 13.5664 19.1149 13.6292 19.0057 13.741C18.8965 13.8528 18.8351 14.0044 18.8351 14.1626V16.1984C18.8351 16.6783 18.6488 17.1385 18.3173 17.4778C17.9858 17.8171 17.5362 18.0077 17.0673 18.0077H6.93265C6.46382 18.0077 6.01418 17.8171 5.68267 17.4778C5.35115 17.1385 5.16491 16.6783 5.16491 16.1984V14.1626C5.16491 14.0044 5.10354 13.8528 4.99431 13.741C4.88508 13.6292 4.73693 13.5664 4.58245 13.5664C4.42798 13.5664 4.27983 13.6292 4.1706 13.741C4.06137 13.8528 4 14.0044 4 14.1626V16.1984C4.00077 16.9942 4.30999 17.7572 4.85981 18.32C5.40962 18.8827 6.1551 19.1992 6.93265 19.2H17.0673C17.8449 19.1992 18.5904 18.8827 19.1402 18.32C19.69 17.7572 19.9992 16.9942 20 16.1984V14.1626C20 14.0044 19.9386 13.8528 19.8294 13.741C19.7202 13.6292 19.572 13.5664 19.4175 13.5664Z"
      fill="#250473"
    />
    <path
      d="M9.08861 8.40972L11.4184 6.02513V14.8779C11.4184 15.036 11.4798 15.1877 11.589 15.2995C11.6982 15.4113 11.8464 15.4741 12.0009 15.4741C12.1554 15.4741 12.3035 15.4113 12.4127 15.2995C12.522 15.1877 12.5833 15.036 12.5833 14.8779V6.03407L14.9131 8.41866C14.9673 8.47405 15.0315 8.51799 15.1022 8.54796C15.1729 8.57794 15.2487 8.59337 15.3252 8.59337C15.4018 8.59337 15.4775 8.57794 15.5482 8.54796C15.619 8.51799 15.6832 8.47405 15.7373 8.41866C15.7914 8.36327 15.8344 8.29752 15.8636 8.22515C15.8929 8.15278 15.908 8.07522 15.908 7.99689C15.908 7.91856 15.8929 7.84099 15.8636 7.76862C15.8344 7.69626 15.7914 7.6305 15.7373 7.57511L12.4144 4.17409C12.3335 4.09371 12.2329 4.03708 12.1232 4.01015C12.0289 3.99239 11.9319 3.998 11.8402 4.02653C11.7484 4.05505 11.6647 4.10565 11.5961 4.17409L8.27317 7.56617C8.1807 7.68005 8.13295 7.82509 8.13922 7.97303C8.14549 8.12097 8.20532 8.26122 8.30708 8.36649C8.40884 8.47175 8.54523 8.53449 8.68969 8.54248C8.83416 8.55047 8.97636 8.50314 9.08861 8.40972Z"
      fill="#250473"
    />
  </svg>
);

export const EMPTY_AVATAR_SVG = () => (
  <svg
    width="87"
    height="87"
    viewBox="0 0 87 87"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="86"
      height="86"
      rx="12.5"
      fill="#C1BECF"
      stroke="#F4F3F9"
    />
    <g clipPath="url(#clip0_4556_29245)">
      <path
        d="M43.022 42.2734C47.4558 42.2734 51.2951 40.6832 54.432 37.5457C57.569 34.4088 59.1592 30.5705 59.1592 26.1362C59.1592 21.7035 57.569 17.8647 54.4315 14.7267C51.294 11.5902 47.4553 10 43.022 10C38.5877 10 34.7494 11.5902 31.6125 14.7272C28.4755 17.8642 26.8848 21.7029 26.8848 26.1362C26.8848 30.5705 28.4755 34.4093 31.613 37.5463C34.7505 40.6827 38.5892 42.2734 43.022 42.2734Z"
        fill="#F4F3F9"
      />
      <path
        d="M71.2577 61.5189C71.1672 60.2134 70.9842 58.7893 70.7149 57.2855C70.4429 55.7704 70.0928 54.3382 69.6736 53.0291C69.2407 51.6761 68.6518 50.3399 67.9239 49.0594C67.1684 47.7304 66.2811 46.5732 65.2853 45.6209C64.2441 44.6246 62.9693 43.8237 61.4951 43.2394C60.0261 42.6582 58.398 42.3638 56.6565 42.3638C55.9726 42.3638 55.3111 42.6444 54.0338 43.4761C53.2476 43.9888 52.328 44.5817 51.3016 45.2375C50.424 45.7967 49.235 46.3207 47.7665 46.795C46.3337 47.2586 44.8789 47.4938 43.4431 47.4938C42.0073 47.4938 40.553 47.2586 39.1187 46.795C37.6517 46.3212 36.4627 45.7972 35.5861 45.238C34.5694 44.5883 33.6493 43.9954 32.8514 43.4756C31.5756 42.6439 30.9136 42.3633 30.2297 42.3633C28.4877 42.3633 26.8601 42.6582 25.3916 43.2399C23.9184 43.8231 22.6431 44.6241 21.6008 45.6214C20.6056 46.5742 19.7177 47.7309 18.9633 49.0594C18.2359 50.3399 17.647 51.6755 17.2136 53.0296C16.7949 54.3387 16.4448 55.7704 16.1729 57.2855C15.9035 58.7873 15.7205 60.2119 15.63 61.5204C15.5411 62.8024 15.4961 64.1329 15.4961 65.4768C15.4961 68.9741 16.6079 71.8054 18.8002 73.8935C20.9655 75.954 23.8305 76.9993 27.3146 76.9993H59.5747C63.0587 76.9993 65.9228 75.9545 68.0885 73.8935C70.2814 71.8069 71.3932 68.9751 71.3932 65.4763C71.3927 64.1263 71.3472 62.7947 71.2577 61.5189Z"
        fill="#F4F3F9"
      />
    </g>
    <defs>
      <clipPath id="clip0_4556_29245">
        <rect
          width="66.9984"
          height="66.9986"
          fill="white"
          transform="translate(10 10)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const SEND_SQUARE_SVG = ({ color = '#090A14' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.18C2 19.83 4.17 22 7.81 22H16.18C19.82 22 21.99 19.83 21.99 16.19V7.81C22 4.17 19.83 2 16.19 2ZM8.64 12.81L13.02 8.43H10.59C10.18 8.43 9.84 8.09 9.84 7.68C9.84 7.27 10.18 6.93 10.59 6.93H14.83C14.93 6.93 15.02 6.95 15.12 6.99C15.3 7.07 15.45 7.21 15.53 7.4C15.57 7.49 15.59 7.59 15.59 7.69V11.93C15.59 12.34 15.25 12.68 14.84 12.68C14.43 12.68 14.09 12.34 14.09 11.93V9.5L9.7 13.87C9.55 14.02 9.36 14.09 9.17 14.09C8.98 14.09 8.79 14.02 8.64 13.87C8.35 13.58 8.35 13.1 8.64 12.81ZM18.24 17.22C16.23 17.89 14.12 18.23 12 18.23C9.88 18.23 7.77 17.89 5.76 17.22C5.37 17.09 5.16 16.66 5.29 16.27C5.42 15.88 5.84 15.66 6.24 15.8C9.96 17.04 14.05 17.04 17.77 15.8C18.16 15.67 18.59 15.88 18.72 16.27C18.84 16.67 18.63 17.09 18.24 17.22Z"
      fill={color}
    />
  </svg>
);

export const TOAST_ERROR_SVG = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.9393 4.625C13.0774 3.125 10.9226 3.125 10.0607 4.625L2.30336 18.125C1.44143 19.625 2.51884 21.5 4.24268 21.5H19.7573C21.4812 21.5 22.5586 19.625 21.6966 18.125L13.9393 4.625ZM12 8.5C12.5523 8.5 13 8.94772 13 9.5V13.5C13 14.0523 12.5523 14.5 12 14.5C11.4477 14.5 11 14.0523 11 13.5V9.5C11 8.94772 11.4477 8.5 12 8.5ZM12 16.5C12.5523 16.5 13 16.9477 13 17.5C13 18.0523 12.5523 18.5 12 18.5C11.4477 18.5 11 18.0523 11 17.5C11 16.9477 11.4477 16.5 12 16.5Z"
      fill="#D84B4B"
    />
  </svg>
);

export const DASHBOARD_SVG = ({ color }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 2C2.90694 2 2 2.90694 2 4V11C2 12.0931 2.90694 13 4 13H9C10.0931 13 11 12.0931 11 11V4C11 2.90694 10.0931 2 9 2H4ZM15 2C13.9069 2 13 2.90694 13 4V7C13 8.09306 13.9069 9 15 9H20C21.0931 9 22 8.09306 22 7V4C22 2.90694 21.0931 2 20 2H15ZM4 4H9V11H4V4ZM15 4H20V7H15V4ZM15 11C13.9069 11 13 11.9069 13 13V20C13 21.0931 13.9069 22 15 22H20C21.0931 22 22 21.0931 22 20V13C22 11.9069 21.0931 11 20 11H15ZM15 13H20V20H15V13ZM4 15C2.90694 15 2 15.9069 2 17V20C2 21.0931 2.90694 22 4 22H9C10.0931 22 11 21.0931 11 20V17C11 15.9069 10.0931 15 9 15H4ZM4 17H9V20H4V17Z"
      fill={color}
    />
  </svg>
);

export const SCHEDULE_SVG = ({ color }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 1C6.448 1 6 1.448 6 2V3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3H18V2C18 1.448 17.552 1 17 1C16.448 1 16 1.448 16 2V3H8V2C8 1.448 7.552 1 7 1ZM5 8H19V18C19 18.552 18.552 19 18 19H6C5.448 19 5 18.552 5 18V8Z"
      fill={color}
    />
  </svg>
);

export const DANCERS_SVG = ({ color }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.5 2C4.854 2 2 6.9098 2 14.8418C2 18.5068 3.03439 20.4107 3.65039 21.2188C4.02739 21.7148 4.60628 22 5.23828 22H9.75977C10.3918 22 10.9717 21.7157 11.3477 21.2207C11.9657 20.4117 13 18.5068 13 14.8418C13 6.9098 10.146 2 7.5 2ZM16.5 2C15.32 2 14.0894 2.9793 13.1094 4.7793C13.5394 5.7193 13.8995 6.76016 14.1895 7.91016L19.3496 12.3301L18.9805 12.75C18.8405 12.91 18.6492 13 18.4492 13H14.9395C14.9795 13.61 15 14.2294 15 14.8594C15 18.2894 14.1794 20.4591 13.3594 21.7891C13.6294 21.9291 13.9302 22 14.2402 22H18.7598C19.3898 22 19.9696 21.7107 20.3496 21.2207C20.9596 20.4107 22 18.5098 22 14.8398C22 6.90984 19.15 2 16.5 2ZM7.5 4C7.84 4 8.50697 4.59717 9.16797 5.82617L4.46289 9.85742C5.26789 5.86042 6.896 4 7.5 4ZM16.5 4C17.1 4 18.7291 5.85938 19.5391 9.85938L14.8301 5.83008C15.4901 4.60008 16.16 4 16.5 4ZM9.98242 7.75977C10.3474 8.85277 10.6463 10.2125 10.8223 11.8145L9.98438 12.7461C9.83638 12.9091 9.64612 13 9.45312 13H5.54688C5.35387 13 5.16363 12.9081 5.01562 12.7441L4.64648 12.334L9.98242 7.75977Z"
      fill={color}
    />
  </svg>
);

export const PARENTS_SVG = ({ color, size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 4C11.0717 4 10.1815 4.36875 9.52513 5.02513C8.86875 5.6815 8.5 6.57174 8.5 7.5C8.5 8.42826 8.86875 9.3185 9.52513 9.97487C10.1815 10.6313 11.0717 11 12 11C12.9283 11 13.8185 10.6313 14.4749 9.97487C15.1313 9.3185 15.5 8.42826 15.5 7.5C15.5 6.57174 15.1313 5.6815 14.4749 5.02513C13.8185 4.36875 12.9283 4 12 4ZM4.5 7C3.83696 7 3.20107 7.26339 2.73223 7.73223C2.26339 8.20107 2 8.83696 2 9.5C2 9.8283 2.06466 10.1534 2.1903 10.4567C2.31594 10.76 2.50009 11.0356 2.73223 11.2678C3.20107 11.7366 3.83696 12 4.5 12C4.8283 12 5.15339 11.9353 5.45671 11.8097C5.76002 11.6841 6.03562 11.4999 6.26777 11.2678C6.49991 11.0356 6.68406 10.76 6.8097 10.4567C6.93534 10.1534 7 9.8283 7 9.5C7 9.1717 6.93534 8.84661 6.8097 8.54329C6.68406 8.23998 6.49991 7.96438 6.26777 7.73223C6.03562 7.50009 5.76002 7.31594 5.45671 7.1903C5.15339 7.06466 4.8283 7 4.5 7ZM19.5 7C18.837 7 18.2011 7.26339 17.7322 7.73223C17.2634 8.20107 17 8.83696 17 9.5C17 9.8283 17.0647 10.1534 17.1903 10.4567C17.3159 10.76 17.5001 11.0356 17.7322 11.2678C18.2011 11.7366 18.837 12 19.5 12C19.8283 12 20.1534 11.9353 20.4567 11.8097C20.76 11.6841 21.0356 11.4999 21.2678 11.2678C21.4999 11.0356 21.6841 10.76 21.8097 10.4567C21.9353 10.1534 22 9.8283 22 9.5C22 8.83696 21.7366 8.20107 21.2678 7.73223C20.7989 7.26339 20.163 7 19.5 7ZM12 13C9.664 13 5 14.173 5 16.5V19C5 19.552 5.448 20 6 20H18C18.552 20 19 19.552 19 19V16.5C19 14.173 14.336 13 12 13ZM3.89844 14.0527C2.31744 14.2967 0 15.3891 0 16.7051V19C0 19.552 0.448 20 1 20H3V16.5C3 15.539 3.34544 14.7327 3.89844 14.0527ZM20.1016 14.0527C20.6546 14.7327 21 15.539 21 16.5V20H23C23.552 20 24 19.552 24 19V16.7051C24 15.3891 21.6826 14.2967 20.1016 14.0527Z"
      fill={color}
    />
  </svg>
);

export const ROUTINES_SVG = ({ color }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 3C11.895 3 11 3.895 11 5V8V14.541C10.3924 14.1882 9.70261 14.0016 9 14C7.93913 14 6.92172 14.4214 6.17157 15.1716C5.42143 15.9217 5 16.9391 5 18C5 19.0609 5.42143 20.0783 6.17157 20.8284C6.92172 21.5786 7.93913 22 9 22C10.0609 22 11.0783 21.5786 11.8284 20.8284C12.5786 20.0783 13 19.0609 13 18V8H16.5C17.881 8 19 6.881 19 5.5C19 4.119 17.881 3 16.5 3H13Z"
      fill={color}
    />
  </svg>
);

export const CLASSES_SVG = ({ color }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 4.5C2.60218 4.5 2.22064 4.65804 1.93934 4.93934C1.65804 5.22064 1.5 5.60218 1.5 6C1.5 6.39782 1.65804 6.77936 1.93934 7.06066C2.22064 7.34196 2.60218 7.5 3 7.5C3.39782 7.5 3.77936 7.34196 4.06066 7.06066C4.34196 6.77936 4.5 6.39782 4.5 6C4.5 5.60218 4.34196 5.22064 4.06066 4.93934C3.77936 4.65804 3.39782 4.5 3 4.5ZM8 5C7.86749 4.99813 7.73593 5.02261 7.61296 5.07202C7.48999 5.12143 7.37807 5.1948 7.2837 5.28784C7.18933 5.38088 7.11439 5.49176 7.06324 5.61401C7.0121 5.73627 6.98576 5.86747 6.98576 6C6.98576 6.13253 7.0121 6.26373 7.06324 6.38599C7.11439 6.50824 7.18933 6.61912 7.2837 6.71216C7.37807 6.8052 7.48999 6.87857 7.61296 6.92798C7.73593 6.97739 7.86749 7.00187 8 7H21C21.1325 7.00187 21.2641 6.97739 21.387 6.92798C21.51 6.87857 21.6219 6.8052 21.7163 6.71216C21.8107 6.61912 21.8856 6.50824 21.9368 6.38599C21.9879 6.26373 22.0142 6.13253 22.0142 6C22.0142 5.86747 21.9879 5.73627 21.9368 5.61401C21.8856 5.49176 21.8107 5.38088 21.7163 5.28784C21.6219 5.1948 21.51 5.12143 21.387 5.07202C21.2641 5.02261 21.1325 4.99813 21 5H8ZM3 10.5C2.60218 10.5 2.22064 10.658 1.93934 10.9393C1.65804 11.2206 1.5 11.6022 1.5 12C1.5 12.3978 1.65804 12.7794 1.93934 13.0607C2.22064 13.342 2.60218 13.5 3 13.5C3.39782 13.5 3.77936 13.342 4.06066 13.0607C4.34196 12.7794 4.5 12.3978 4.5 12C4.5 11.6022 4.34196 11.2206 4.06066 10.9393C3.77936 10.658 3.39782 10.5 3 10.5ZM8 11C7.86749 10.9981 7.73593 11.0226 7.61296 11.072C7.48999 11.1214 7.37807 11.1948 7.2837 11.2878C7.18933 11.3809 7.11439 11.4918 7.06324 11.614C7.0121 11.7363 6.98576 11.8675 6.98576 12C6.98576 12.1325 7.0121 12.2637 7.06324 12.386C7.11439 12.5082 7.18933 12.6191 7.2837 12.7122C7.37807 12.8052 7.48999 12.8786 7.61296 12.928C7.73593 12.9774 7.86749 13.0019 8 13H21C21.1325 13.0019 21.2641 12.9774 21.387 12.928C21.51 12.8786 21.6219 12.8052 21.7163 12.7122C21.8107 12.6191 21.8856 12.5082 21.9368 12.386C21.9879 12.2637 22.0142 12.1325 22.0142 12C22.0142 11.8675 21.9879 11.7363 21.9368 11.614C21.8856 11.4918 21.8107 11.3809 21.7163 11.2878C21.6219 11.1948 21.51 11.1214 21.387 11.072C21.2641 11.0226 21.1325 10.9981 21 11H8ZM3 16.5C2.60218 16.5 2.22064 16.658 1.93934 16.9393C1.65804 17.2206 1.5 17.6022 1.5 18C1.5 18.3978 1.65804 18.7794 1.93934 19.0607C2.22064 19.342 2.60218 19.5 3 19.5C3.39782 19.5 3.77936 19.342 4.06066 19.0607C4.34196 18.7794 4.5 18.3978 4.5 18C4.5 17.6022 4.34196 17.2206 4.06066 16.9393C3.77936 16.658 3.39782 16.5 3 16.5ZM8 17C7.86749 16.9981 7.73593 17.0226 7.61296 17.072C7.48999 17.1214 7.37807 17.1948 7.2837 17.2878C7.18933 17.3809 7.11439 17.4918 7.06324 17.614C7.0121 17.7363 6.98576 17.8675 6.98576 18C6.98576 18.1325 7.0121 18.2637 7.06324 18.386C7.11439 18.5082 7.18933 18.6191 7.2837 18.7122C7.37807 18.8052 7.48999 18.8786 7.61296 18.928C7.73593 18.9774 7.86749 19.0019 8 19H21C21.1325 19.0019 21.2641 18.9774 21.387 18.928C21.51 18.8786 21.6219 18.8052 21.7163 18.7122C21.8107 18.6191 21.8856 18.5082 21.9368 18.386C21.9879 18.2637 22.0142 18.1325 22.0142 18C22.0142 17.8675 21.9879 17.7363 21.9368 17.614C21.8856 17.4918 21.8107 17.3809 21.7163 17.2878C21.6219 17.1948 21.51 17.1214 21.387 17.072C21.2641 17.0226 21.1325 16.9981 21 17H8Z"
      fill={color}
    />
  </svg>
);

export const EVENTS_SVG = ({ color }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 4C2.9 4 2 4.9 2 6V9.15039C2 9.56539 2.23786 9.97056 2.63086 10.1016C3.42486 10.3676 4 11.12 4 12C4 12.88 3.42486 13.6324 2.63086 13.8984C2.23786 14.0294 2 14.4346 2 14.8496V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V14.8496C22 14.4346 21.7621 14.0294 21.3691 13.8984C20.5751 13.6324 20 12.88 20 12C20 11.12 20.5751 10.3676 21.3691 10.1016C21.7621 9.97056 22 9.56539 22 9.15039V6C22 4.9 21.1 4 20 4H4ZM12 6.80078L13.4004 10.0996L17 10.4004L14.3008 12.8008L15.0996 16.1992L12 14.4004L8.90039 16.3008L9.69922 12.8008L7 10.4004L10.5996 10.0996L12 6.80078Z"
      fill={color}
    />
  </svg>
);

export const REPORTS_SVG = ({ color }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.13 2H5.95801C4.85801 2 3.95801 2.9 3.95801 4V20C3.95801 21.1 4.85801 22 5.95801 22H17.958C19.058 22 19.958 21.1 19.958 20V8.828C19.958 8.298 19.747 7.789 19.372 7.414L14.544 2.586C14.169 2.211 13.66 2 13.13 2ZM11.255 17.711L9.95801 16.414L8.70701 17.707C8.31701 18.097 7.68301 18.097 7.29301 17.707C6.90301 17.317 6.90301 16.683 7.29301 16.293L9.25101 14.304C9.64101 13.908 10.278 13.906 10.671 14.298L11.958 15.585L14.293 13.292C14.683 12.902 15.317 12.902 15.707 13.292C16.097 13.682 16.097 14.316 15.707 14.706L12.665 17.714C12.274 18.102 11.644 18.1 11.255 17.711ZM12.958 9V3.5L18.458 9H12.958Z"
      fill={color}
    />
  </svg>
);

export const BILLING_SVG = ({ color }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 2C19 2.552 18.552 3 18 3C17.448 3 17 2.552 17 2H15C15 2.552 14.552 3 14 3C13.448 3 13 2.552 13 2H11C11 2.552 10.552 3 10 3C9.448 3 9 2.552 9 2H7C7 2.552 6.552 3 6 3C5.448 3 5 2.552 5 2H4C3.448 2 3 2.448 3 3V20C3 21.105 3.895 22 5 22H19C20.105 22 21 21.105 21 20V3C21 2.448 20.552 2 20 2H19ZM13 18H7C6.448 18 6 17.552 6 17C6 16.448 6.448 16 7 16H13C13.552 16 14 16.448 14 17C14 17.552 13.552 18 13 18ZM13 14H7C6.448 14 6 13.552 6 13C6 12.448 6.448 12 7 12H13C13.552 12 14 12.448 14 13C14 13.552 13.552 14 13 14ZM17.5 18H16.5C16.224 18 16 17.776 16 17.5V16.5C16 16.224 16.224 16 16.5 16H17.5C17.776 16 18 16.224 18 16.5V17.5C18 17.776 17.776 18 17.5 18ZM17.5 14H16.5C16.224 14 16 13.776 16 13.5V12.5C16 12.224 16.224 12 16.5 12H17.5C17.776 12 18 12.224 18 12.5V13.5C18 13.776 17.776 14 17.5 14ZM17 9H7C6.448 9 6 8.552 6 8C6 7.448 6.448 7 7 7H17C17.552 7 18 7.448 18 8C18 8.552 17.552 9 17 9Z"
      fill={color}
    />
  </svg>
);

export const PROPOSALS_SVG = ({ color }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 2C19 2.552 18.552 3 18 3C17.448 3 17 2.552 17 2H15C15 2.552 14.552 3 14 3C13.448 3 13 2.552 13 2H11C11 2.552 10.552 3 10 3C9.448 3 9 2.552 9 2H7C7 2.552 6.552 3 6 3C5.448 3 5 2.552 5 2H4C3.448 2 3 2.448 3 3V20C3 21.105 3.895 22 5 22H19C20.105 22 21 21.105 21 20V3C21 2.448 20.552 2 20 2H19ZM13 18H7C6.448 18 6 17.552 6 17C6 16.448 6.448 16 7 16H13C13.552 16 14 16.448 14 17C14 17.552 13.552 18 13 18ZM13 14H7C6.448 14 6 13.552 6 13C6 12.448 6.448 12 7 12H13C13.552 12 14 12.448 14 13C14 13.552 13.552 14 13 14ZM17.5 18H16.5C16.224 18 16 17.776 16 17.5V16.5C16 16.224 16.224 16 16.5 16H17.5C17.776 16 18 16.224 18 16.5V17.5C18 17.776 17.776 18 17.5 18ZM17.5 14H16.5C16.224 14 16 13.776 16 13.5V12.5C16 12.224 16.224 12 16.5 12H17.5C17.776 12 18 12.224 18 12.5V13.5C18 13.776 17.776 14 17.5 14ZM17 9H7C6.448 9 6 8.552 6 8C6 7.448 6.448 7 7 7H17C17.552 7 18 7.448 18 8C18 8.552 17.552 9 17 9Z"
      fill={color}
    />
  </svg>
);

export const MEDIA_SVG = ({ color }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 2C6.45 2 6 2.45 6 3C6 3.55 6.45 4 7 4H17C17.55 4 18 3.55 18 3C18 2.45 17.55 2 17 2H7ZM5 5C4.45 5 4 5.45 4 6C4 6.55 4.45 7 5 7H19C19.55 7 20 6.55 20 6C20 5.45 19.55 5 19 5H5ZM5 8C3.897 8 3 8.897 3 10V20C3 21.103 3.897 22 5 22H19C20.103 22 21 21.103 21 20V10C21 8.897 20.103 8 19 8H5ZM5.5 10H6.5C6.776 10 7 10.224 7 10.5V11.5C7 11.776 6.776 12 6.5 12H5.5C5.224 12 5 11.776 5 11.5V10.5C5 10.224 5.224 10 5.5 10ZM17.5 10H18.5C18.776 10 19 10.224 19 10.5V11.5C19 11.776 18.776 12 18.5 12H17.5C17.224 12 17 11.776 17 11.5V10.5C17 10.224 17.224 10 17.5 10ZM5.5 14H6.5C6.776 14 7 14.224 7 14.5V15.5C7 15.776 6.776 16 6.5 16H5.5C5.224 16 5 15.776 5 15.5V14.5C5 14.224 5.224 14 5.5 14ZM17.5 14H18.5C18.776 14 19 14.224 19 14.5V15.5C19 15.776 18.776 16 18.5 16H17.5C17.224 16 17 15.776 17 15.5V14.5C17 14.224 17.224 14 17.5 14ZM5.5 18H6.5C6.776 18 7 18.224 7 18.5V19.5C7 19.776 6.776 20 6.5 20H5.5C5.224 20 5 19.776 5 19.5V18.5C5 18.224 5.224 18 5.5 18ZM17.5 18H18.5C18.776 18 19 18.224 19 18.5V19.5C19 19.776 18.776 20 18.5 20H17.5C17.224 20 17 19.776 17 19.5V18.5C17 18.224 17.224 18 17.5 18Z"
      fill={color}
    />
  </svg>
);

export const HELP_SVG = ({ color }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12.5 19H11.5C11.224 19 11 18.776 11 18.5V17.5C11 17.224 11.224 17 11.5 17H12.5C12.776 17 13 17.224 13 17.5V18.5C13 18.776 12.776 19 12.5 19ZM15.07 11.25L14.17 12.17C13.45 12.9 13 13.5 13 15H11V14.5C11 13.4 11.45 12.4 12.17 11.67L13.41 10.41C13.867 9.966 14.095 9.308 13.963 8.607C13.828 7.89 13.275 7.28 12.574 7.081C11.468 6.767 10.437 7.4 10.108 8.353C9.98 8.724 9.668 9 9.275 9H8.984C8.403 9 7.997 8.436 8.159 7.878C8.588 6.406 9.84 5.285 11.384 5.047C12.908 4.812 14.353 5.596 15.257 6.846C16.437 8.478 16.089 10.231 15.07 11.25Z"
      fill={color}
    />
  </svg>
);

export const MESSAGE_SVG = ({ color = '#7E7B8F' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.1525 21.4201C1.78114 21.4181 1.42555 21.2697 1.16296 21.0071C0.900366 20.7445 0.75197 20.3889 0.75 20.0176V8.48258C0.75198 7.7134 1.05841 6.97628 1.60231 6.43239C2.14621 5.88849 2.88332 5.58206 3.6525 5.58008H17.34C18.1105 5.58008 18.8495 5.88563 19.395 6.42974C19.9405 6.97385 20.248 7.7121 20.25 8.48258V16.1701C20.25 16.9406 19.9444 17.6796 19.4003 18.2251C18.8562 18.7706 18.118 19.0781 17.3475 19.0801H5.9325C5.80285 19.0811 5.67685 19.1231 5.5725 19.2001L3 21.1426C2.75471 21.3238 2.4575 21.4212 2.1525 21.4201ZM3.6525 7.08008C3.28114 7.08205 2.92555 7.23044 2.66296 7.49304C2.40037 7.75563 2.25197 8.11122 2.25 8.48258V19.8301L4.6725 18.0001C5.037 17.7294 5.47847 17.5822 5.9325 17.5801H17.34C17.714 17.5801 18.0726 17.4315 18.337 17.1671C18.6014 16.9027 18.75 16.544 18.75 16.1701V8.48258C18.748 8.11122 18.5996 7.75563 18.337 7.49304C18.0744 7.23044 17.7189 7.08205 17.3475 7.08008H3.6525Z"
      fill={color}
    />
    <path
      d="M13.455 13.1475C13.8692 13.1475 14.205 12.8117 14.205 12.3975C14.205 11.9832 13.8692 11.6475 13.455 11.6475C13.0407 11.6475 12.705 11.9832 12.705 12.3975C12.705 12.8117 13.0407 13.1475 13.455 13.1475Z"
      fill={color}
    />
    <path
      d="M10.545 13.1475C10.9593 13.1475 11.295 12.8117 11.295 12.3975C11.295 11.9832 10.9593 11.6475 10.545 11.6475C10.1308 11.6475 9.79504 11.9832 9.79504 12.3975C9.79504 12.8117 10.1308 13.1475 10.545 13.1475Z"
      fill={color}
    />
    <path
      d="M7.54504 13.1475C7.95926 13.1475 8.29504 12.8117 8.29504 12.3975C8.29504 11.9832 7.95926 11.6475 7.54504 11.6475C7.13083 11.6475 6.79504 11.9832 6.79504 12.3975C6.79504 12.8117 7.13083 13.1475 7.54504 13.1475Z"
      fill={color}
    />
    <path
      d="M22.5 13.8301C22.3011 13.8301 22.1103 13.7511 21.9697 13.6104C21.829 13.4698 21.75 13.279 21.75 13.0801V5.48258C21.748 5.11122 21.5996 4.75563 21.337 4.49304C21.0744 4.23044 20.7189 4.08205 20.3475 4.08008H5.25C5.05109 4.08008 4.86032 4.00106 4.71967 3.86041C4.57902 3.71976 4.5 3.52899 4.5 3.33008C4.5 3.13117 4.57902 2.9404 4.71967 2.79975C4.86032 2.6591 5.05109 2.58008 5.25 2.58008H20.3475C21.1167 2.58206 21.8538 2.88849 22.3977 3.43239C22.9416 3.97628 23.248 4.7134 23.25 5.48258V13.0801C23.25 13.279 23.171 13.4698 23.0303 13.6104C22.8897 13.7511 22.6989 13.8301 22.5 13.8301Z"
      fill={color}
    />
  </svg>
);

export const FILTER_SVG = () => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.5 9C4.94772 9 4.5 9.44772 4.5 10C4.5 10.5523 4.94772 11 5.5 11V9ZM15.5 11C16.0523 11 16.5 10.5523 16.5 10C16.5 9.44772 16.0523 9 15.5 9V11ZM3 4C2.44772 4 2 4.44772 2 5C2 5.55228 2.44772 6 3 6V4ZM18 6C18.5523 6 19 5.55228 19 5C19 4.44772 18.5523 4 18 4V6ZM8 14C7.44772 14 7 14.4477 7 15C7 15.5523 7.44772 16 8 16V14ZM13 16C13.5523 16 14 15.5523 14 15C14 14.4477 13.5523 14 13 14V16ZM5.5 11H15.5V9H5.5V11ZM3 6H18V4H3V6ZM8 16H13V14H8V16Z"
      fill="#101828"
    />
  </svg>
);

export const AGE_RANGE_SVG = ({ color }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.2761 5.71191C16.357 5.71191 14.7725 7.17117 14.5734 9.03832C15.9663 9.90242 16.8959 11.4453 16.8959 13.2015V15.712C16.8959 16.6277 16.4832 17.4696 15.8074 18.0304V21.402C15.8074 21.7256 16.0697 21.988 16.3933 21.988H20.1589C20.4825 21.988 20.7449 21.7256 20.7449 21.402V15.5747C21.4737 15.3294 22.0001 14.6396 22.0001 13.8291V9.43586C22.0001 7.3825 20.3295 5.71191 18.2761 5.71191Z"
      fill={color}
    />
    <path
      d="M18.2761 5.71182C19.3027 5.71182 20.138 4.87655 20.138 3.84983C20.0445 1.38303 16.5073 1.38374 16.4141 3.84987C16.4141 4.87655 17.2493 5.71182 18.2761 5.71182Z"
      fill={color}
    />
    <path
      d="M13.862 7.61541C13.862 6.58869 13.0268 5.75342 12.0001 5.75342C9.53325 5.84701 9.53392 9.38416 12.0001 9.4774C13.0267 9.4774 13.862 8.64213 13.862 7.61541Z"
      fill={color}
    />
    <path
      d="M12.0001 9.47754C10.081 9.47754 8.49649 10.9368 8.29742 12.8039C9.69028 13.668 10.6199 15.2109 10.6199 16.9671V17.5947C10.6199 18.5105 10.2072 19.3523 9.53137 19.9132V21.402C9.53137 21.7256 9.79371 21.988 10.1173 21.988H13.8829C14.2065 21.988 14.4689 21.7256 14.4689 21.402V17.4575C15.1977 17.2122 15.7241 16.5224 15.7241 15.7119V13.2015C15.7241 11.1481 14.0535 9.47754 12.0001 9.47754Z"
      fill={color}
    />
    <path
      d="M5.72394 13.2432C3.66355 13.2432 2 14.9109 2 16.9671V17.5947C2 18.4052 2.52633 19.095 3.2552 19.3403V21.402C3.2552 21.7256 3.51754 21.9879 3.84113 21.9879H7.60676C7.93035 21.9879 8.1927 21.7256 8.1927 21.402V19.3403C8.92156 19.095 9.44789 18.4052 9.44789 17.5947V16.9671C9.44793 14.907 7.78066 13.2432 5.72394 13.2432Z"
      fill={color}
    />
    <path
      d="M5.72399 13.2431C6.75067 13.2431 7.58598 12.4078 7.58598 11.3811C7.49239 8.91428 3.95524 8.91499 3.862 11.3811C3.86204 12.4078 4.69731 13.2431 5.72399 13.2431Z"
      fill={color}
    />
  </svg>
);

export const CROSS_SVG = ({ color = '#4F5163', size = 20, style }) => (
  <svg
    width={size}
    height={size}
    style={style}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 5L14 14"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M14 5L5 14"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const CITY_SVG = ({ color }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22 20.2502H20.25V17.3722C20.7559 17.2141 21.1983 16.8989 21.5129 16.4724C21.8276 16.0459 21.9982 15.5302 22 15.0002V12.0002C22 11.3372 21.7366 10.7013 21.2678 10.2325C20.7989 9.76361 20.163 9.50022 19.5 9.50022C18.837 9.50022 18.2011 9.76361 17.7322 10.2325C17.2634 10.7013 17 11.3372 17 12.0002V15.0002C17.0018 15.5302 17.1724 16.0459 17.4871 16.4724C17.8017 16.8989 18.2441 17.2141 18.75 17.3722V20.2502H15V6.00022C15.0581 5.59272 15.0206 5.17727 14.8904 4.78678C14.7602 4.39628 14.5409 4.04145 14.2498 3.75039C13.9588 3.45932 13.6039 3.24 13.2134 3.1098C12.8229 2.9796 12.4075 2.94208 12 3.00022H6C5.5925 2.94208 5.17705 2.9796 4.78655 3.1098C4.39606 3.24 4.04123 3.45932 3.75016 3.75039C3.4591 4.04145 3.23978 4.39628 3.10958 4.78678C2.97937 5.17727 2.94186 5.59272 3 6.00022V20.2502H2C1.80109 20.2502 1.61032 20.3292 1.46967 20.4699C1.32902 20.6105 1.25 20.8013 1.25 21.0002C1.25 21.1991 1.32902 21.3899 1.46967 21.5306C1.61032 21.6712 1.80109 21.7502 2 21.7502H22C22.1989 21.7502 22.3897 21.6712 22.5303 21.5306C22.671 21.3899 22.75 21.1991 22.75 21.0002C22.75 20.8013 22.671 20.6105 22.5303 20.4699C22.3897 20.3292 22.1989 20.2502 22 20.2502ZM10.5 7.25022H11.5C11.6989 7.25022 11.8897 7.32924 12.0303 7.46989C12.171 7.61054 12.25 7.80131 12.25 8.00022C12.25 8.19913 12.171 8.3899 12.0303 8.53055C11.8897 8.6712 11.6989 8.75022 11.5 8.75022H10.5C10.3011 8.75022 10.1103 8.6712 9.96967 8.53055C9.82902 8.3899 9.75 8.19913 9.75 8.00022C9.75 7.80131 9.82902 7.61054 9.96967 7.46989C10.1103 7.32924 10.3011 7.25022 10.5 7.25022ZM10.5 10.2502H11.5C11.6989 10.2502 11.8897 10.3292 12.0303 10.4699C12.171 10.6105 12.25 10.8013 12.25 11.0002C12.25 11.1991 12.171 11.3899 12.0303 11.5306C11.8897 11.6712 11.6989 11.7502 11.5 11.7502H10.5C10.3011 11.7502 10.1103 11.6712 9.96967 11.5306C9.82902 11.3899 9.75 11.1991 9.75 11.0002C9.75 10.8013 9.82902 10.6105 9.96967 10.4699C10.1103 10.3292 10.3011 10.2502 10.5 10.2502ZM6.5 7.25022H7.5C7.69891 7.25022 7.88968 7.32924 8.03033 7.46989C8.17098 7.61054 8.25 7.80131 8.25 8.00022C8.25 8.19913 8.17098 8.3899 8.03033 8.53055C7.88968 8.6712 7.69891 8.75022 7.5 8.75022H6.5C6.30109 8.75022 6.11032 8.6712 5.96967 8.53055C5.82902 8.3899 5.75 8.19913 5.75 8.00022C5.75 7.80131 5.82902 7.61054 5.96967 7.46989C6.11032 7.32924 6.30109 7.25022 6.5 7.25022ZM6.5 10.2502H7.5C7.69891 10.2502 7.88968 10.3292 8.03033 10.4699C8.17098 10.6105 8.25 10.8013 8.25 11.0002C8.25 11.1991 8.17098 11.3899 8.03033 11.5306C7.88968 11.6712 7.69891 11.7502 7.5 11.7502H6.5C6.30109 11.7502 6.11032 11.6712 5.96967 11.5306C5.82902 11.3899 5.75 11.1991 5.75 11.0002C5.75 10.8013 5.82902 10.6105 5.96967 10.4699C6.11032 10.3292 6.30109 10.2502 6.5 10.2502ZM7 17.0002C7 16.4698 7.21071 15.9611 7.58579 15.586C7.96086 15.2109 8.46957 15.0002 9 15.0002C9.53043 15.0002 10.0391 15.2109 10.4142 15.586C10.7893 15.9611 11 16.4698 11 17.0002V20.2502H7V17.0002Z"
      fill={color}
    />
  </svg>
);

export const BIRTHDATE_SVG = ({ color }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 4H18V3C18 2.44775 17.5527 2 17 2C16.4473 2 16 2.44775 16 3V4H13V3C13 2.44775 12.5527 2 12 2C11.4473 2 11 2.44775 11 3V4H8V3C8 2.44775 7.55273 2 7 2C6.44727 2 6 2.44775 6 3V4H5C3.3457 4 2 5.3457 2 7V19C2 20.6543 3.3457 22 5 22H19C20.6543 22 22 20.6543 22 19V7C22 5.3457 20.6543 4 19 4ZM20 19C20 19.5513 19.5518 20 19 20H16V18.5C16 17.1216 14.8789 16 13.5 16H10.5C9.12109 16 8 17.1216 8 18.5V20H5C4.44824 20 4 19.5513 4 19V7C4 6.44873 4.44824 6 5 6H19C19.5518 6 20 6.44873 20 7V19ZM12 8C10.0703 8 8.5 9.57031 8.5 11.5C8.5 13.4297 10.0703 15 12 15C13.9297 15 15.5 13.4297 15.5 11.5C15.5 9.57031 13.9297 8 12 8Z"
      fill={color}
    />
  </svg>
);

export const DATE_PICKER_LEFT_CHEVRON_SVG = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.24651 7.57967C4.24841 7.44955 4.30096 7.32531 4.39299 7.23331L10.893 0.733314C10.9391 0.685328 10.9942 0.647018 11.0553 0.620626C11.1164 0.594235 11.1821 0.580292 11.2486 0.579616C11.3151 0.57894 11.3811 0.591543 11.4427 0.616687C11.5043 0.641832 11.5602 0.679012 11.6073 0.726051C11.6543 0.77309 11.6915 0.829042 11.7167 0.89063C11.7418 0.952218 11.7544 1.0182 11.7537 1.08472C11.753 1.15124 11.7391 1.21696 11.7127 1.27802C11.6863 1.33909 11.648 1.39427 11.6 1.44035L5.45354 7.58683L11.6 13.7333C11.648 13.7794 11.6863 13.8346 11.7127 13.8956C11.7391 13.9567 11.753 14.0224 11.7537 14.0889C11.7544 14.1555 11.7418 14.2214 11.7166 14.283C11.6915 14.3446 11.6543 14.4006 11.6073 14.4476C11.5602 14.4946 11.5043 14.5318 11.4427 14.557C11.3811 14.5821 11.3151 14.5947 11.2486 14.594C11.1821 14.5934 11.1164 14.5794 11.0553 14.553C10.9942 14.5266 10.9391 14.4883 10.893 14.4403L4.39299 7.94035C4.3457 7.89307 4.30837 7.8368 4.28321 7.77485C4.25805 7.7129 4.24557 7.64653 4.24651 7.57967Z"
      fill="black"
    />
  </svg>
);

export const DATE_PICKER_RIGHT_CHEVRON_SVG = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.7536 7.57967C11.7517 7.44955 11.6992 7.32531 11.6071 7.23331L5.10713 0.733313C5.06106 0.685328 5.00587 0.647017 4.94481 0.620626C4.88374 0.594234 4.81803 0.580292 4.75151 0.579615C4.68499 0.578939 4.619 0.591542 4.55742 0.616687C4.49583 0.641831 4.43988 0.679012 4.39284 0.726051C4.3458 0.77309 4.30862 0.829042 4.28347 0.89063C4.25833 0.952218 4.24572 1.0182 4.2464 1.08472C4.24708 1.15124 4.26102 1.21696 4.28741 1.27802C4.3138 1.33909 4.35211 1.39427 4.4001 1.44034L10.5466 7.58683L4.4001 13.7333C4.35211 13.7794 4.3138 13.8346 4.28741 13.8956C4.26102 13.9567 4.24708 14.0224 4.2464 14.0889C4.24572 14.1555 4.25833 14.2214 4.28347 14.283C4.30862 14.3446 4.3458 14.4006 4.39284 14.4476C4.43987 14.4946 4.49583 14.5318 4.55741 14.557C4.619 14.5821 4.68499 14.5947 4.75151 14.594C4.81803 14.5934 4.88374 14.5794 4.94481 14.553C5.00587 14.5266 5.06106 14.4883 5.10713 14.4403L11.6071 7.94035C11.6544 7.89307 11.6917 7.8368 11.7169 7.77485C11.7421 7.7129 11.7546 7.64653 11.7536 7.57967Z"
      fill="black"
    />
  </svg>
);

export const SMS_SVG = () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="2"
      y="2"
      width="32"
      height="32"
      rx="16"
      fill="#F4EBFF"
    />
    <rect
      x="2"
      y="2"
      width="32"
      height="32"
      rx="16"
      stroke="#F9F5FF"
      strokeWidth="4"
    />
    <mask
      id="mask0_4950_19744"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="10"
      y="9"
      width="16"
      height="16"
    >
      <path
        d="M10 9H26V25H10V9Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_4950_19744)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.9977 9.05322C19.1936 9.05254 20.3743 9.3218 21.4516 9.84091C22.5291 10.36 23.4755 11.1157 24.2203 12.0515C24.965 12.9873 25.489 14.0791 25.753 15.2456C26.0171 16.4121 26.0144 17.6232 25.7454 18.7885C25.4762 19.9538 24.9475 21.0433 24.1986 21.9759C23.4498 22.9085 22.5001 23.6599 21.4204 24.1744C20.3407 24.6888 19.1588 24.9529 17.9628 24.947C16.8304 24.9414 15.7129 24.6939 14.6851 24.2217L10.724 24.938C10.5216 24.9745 10.3152 24.8996 10.1835 24.7416C10.0518 24.5837 10.0151 24.3671 10.0874 24.1747L11.2237 21.1516C10.5262 20.0129 10.1259 18.7153 10.0622 17.3784C9.9938 15.9425 10.3161 14.515 10.9949 13.2478C11.6736 11.9807 12.6834 10.9214 13.9165 10.1827C15.1497 9.44405 16.5602 9.0537 17.9977 9.05322ZM14.3158 16.9984L14.3163 17.0002L14.3158 17.0019L14.3152 17.003L14.314 17.0037L14.3123 17.0042L14.3105 17.0037L14.3094 17.003L14.3087 17.0019L14.3082 17.0002L14.3087 16.9984L14.3094 16.9973L14.3105 16.9966L14.3123 16.9961L14.314 16.9966L14.3152 16.9973L14.3158 16.9984ZM14.3123 15.8614C13.6833 15.8614 13.1735 16.3712 13.1735 17.0002C13.1735 17.6291 13.6833 18.1389 14.3123 18.1389C14.9412 18.1389 15.451 17.6291 15.451 17.0002C15.451 16.3712 14.9412 15.8614 14.3123 15.8614ZM18.0041 17.0002L18.0035 16.9984L18.0029 16.9973L18.0018 16.9966L18 16.9961L17.9983 16.9966L17.9971 16.9973L17.9965 16.9984L17.996 17.0002L17.9965 17.0019L17.9971 17.003L17.9983 17.0037L18 17.0042L18.0018 17.0037L18.0029 17.003L18.0035 17.0019L18.0041 17.0002ZM16.8613 17.0002C16.8613 16.3712 17.3711 15.8614 18 15.8614C18.629 15.8614 19.1388 16.3712 19.1388 17.0002C19.1388 17.6291 18.629 18.1389 18 18.1389C17.3711 18.1389 16.8613 17.6291 16.8613 17.0002ZM21.6913 16.9984L21.6919 17.0002L21.6913 17.0019L21.6906 17.003L21.6896 17.0037L21.6878 17.0042L21.686 17.0037L21.6849 17.003L21.6842 17.0019L21.6838 17.0002L21.6842 16.9984L21.6849 16.9973L21.686 16.9966L21.6878 16.9961L21.6896 16.9966L21.6906 16.9973L21.6913 16.9984ZM21.6878 15.8614C21.0589 15.8614 20.549 16.3712 20.549 17.0002C20.549 17.6291 21.0589 18.1389 21.6878 18.1389C22.3167 18.1389 22.8265 17.6291 22.8265 17.0002C22.8265 16.3712 22.3167 15.8614 21.6878 15.8614Z"
        fill="#7A7AE4"
      />
    </g>
  </svg>
);

export const EMAIL_SVG = () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="2"
      y="2"
      width="32"
      height="32"
      rx="16"
      fill="#F4EBFF"
    />
    <rect
      x="2"
      y="2"
      width="32"
      height="32"
      rx="16"
      stroke="#F9F5FF"
      strokeWidth="4"
    />
    <path
      d="M11.125 11.3335C10.32 11.3335 9.66663 11.9868 9.66663 12.7918L18 18.0002L26.3333 12.7918C26.3333 11.9868 25.68 11.3335 24.875 11.3335H11.125ZM9.66663 14.4601V23.0002C9.66663 23.921 10.4125 24.6668 11.3333 24.6668H24.6666C25.5875 24.6668 26.3333 23.921 26.3333 23.0002V14.4601L18 19.6668L9.66663 14.4601Z"
      fill="#7A7AE4"
    />
  </svg>
);

export const POPUP_BTN_CHEVRON_SVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.6305 11.3697C17.6276 11.1746 17.5488 10.9882 17.4108 10.8502L7.66076 1.10021C7.59165 1.02824 7.50887 0.97077 7.41727 0.931182C7.32568 0.891595 7.2271 0.870682 7.12732 0.869667C7.02754 0.868653 6.92857 0.887557 6.83618 0.925274C6.7438 0.962991 6.65987 1.01876 6.58932 1.08932C6.51876 1.15988 6.46299 1.24381 6.42527 1.33619C6.38755 1.42857 6.36865 1.52755 6.36966 1.62733C6.37068 1.72711 6.39159 1.82568 6.43118 1.91728C6.47076 2.00888 6.52823 2.09165 6.60021 2.16076L15.8199 11.3805L6.60021 20.6002C6.52823 20.6693 6.47076 20.7521 6.43118 20.8437C6.39159 20.9353 6.37068 21.0339 6.36966 21.1336C6.36865 21.2334 6.38755 21.3324 6.42527 21.4248C6.46299 21.5172 6.51876 21.6011 6.58931 21.6717C6.65987 21.7422 6.7438 21.798 6.83618 21.8357C6.92856 21.8734 7.02754 21.8923 7.12732 21.8913C7.2271 21.8903 7.32568 21.8694 7.41727 21.8298C7.50887 21.7902 7.59164 21.7327 7.66075 21.6608L17.4108 11.9108C17.4817 11.8399 17.5377 11.7554 17.5754 11.6625C17.6132 11.5696 17.6319 11.47 17.6305 11.3697Z"
      fill="#7A7AE4"
    />
  </svg>
);

export const SORTING_ARROW_SVG = ({ isUp, color = '#667085' }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ transform: isUp ? 'rotate(180deg)' : '' }}
  >
    <path
      d="M7.99992 3.3335V12.6668M7.99992 12.6668L12.6666 8.00016M7.99992 12.6668L3.33325 8.00016"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PLUS_SVG = ({ size = 20, color = '#090A14' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24 12C24 12.3819 23.8483 12.7482 23.5782 13.0182C23.3082 13.2883 22.9419 13.44 22.56 13.44H13.44V22.56C13.44 22.9419 13.2883 23.3082 13.0182 23.5782C12.7482 23.8483 12.3819 24 12 24C11.6181 24 11.2518 23.8483 10.9818 23.5782C10.7117 23.3082 10.56 22.9419 10.56 22.56V13.44H1.44C1.05809 13.44 0.691819 13.2883 0.421766 13.0182C0.151714 12.7482 0 12.3819 0 12C0 11.6181 0.151714 11.2518 0.421766 10.9818C0.691819 10.7117 1.05809 10.56 1.44 10.56H10.56V1.44C10.56 1.05809 10.7117 0.691819 10.9818 0.421766C11.2518 0.151714 11.6181 0 12 0C12.3819 0 12.7482 0.151714 13.0182 0.421766C13.2883 0.691819 13.44 1.05809 13.44 1.44V10.56H22.56C22.9419 10.56 23.3082 10.7117 23.5782 10.9818C23.8483 11.2518 24 11.6181 24 12Z"
      fill={color}
    />
  </svg>
);

export const TABLE_CHEVRON_SVG = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.6921 19.4747C24.6897 19.3121 24.624 19.1568 24.509 19.0418L16.384 10.9168C16.3264 10.8568 16.2574 10.8089 16.1811 10.7759C16.1047 10.7429 16.0226 10.7255 15.9394 10.7246C15.8563 10.7238 15.7738 10.7395 15.6968 10.771C15.6198 10.8024 15.5499 10.8489 15.4911 10.9077C15.4323 10.9665 15.3858 11.0364 15.3544 11.1134C15.323 11.1904 15.3072 11.2729 15.3081 11.356C15.3089 11.4392 15.3263 11.5213 15.3593 11.5977C15.3923 11.674 15.4402 11.743 15.5002 11.8006L23.1833 19.4837L15.5002 27.1668C15.4402 27.2244 15.3923 27.2933 15.3593 27.3697C15.3263 27.446 15.3089 27.5281 15.3081 27.6113C15.3072 27.6944 15.323 27.7769 15.3544 27.8539C15.3858 27.9309 15.4323 28.0008 15.4911 28.0596C15.5499 28.1184 15.6198 28.1649 15.6968 28.1963C15.7738 28.2278 15.8563 28.2435 15.9394 28.2427C16.0226 28.2418 16.1047 28.2244 16.1811 28.1914C16.2574 28.1584 16.3264 28.1105 16.384 28.0506L24.509 19.9256C24.5681 19.8665 24.6147 19.7961 24.6462 19.7187C24.6776 19.6412 24.6932 19.5583 24.6921 19.4747Z"
      fill="#C1BECF"
    />
  </svg>
);

export const DATE_SELECTOR_CHEVRON_LEFT_SVG = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 24L12 16L20 8"
      stroke="#676770"
      strokeWidth="2.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DATE_SELECTOR_CHEVRON_RIGHT_SVG = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 24L20 16L12 8"
      stroke="#676770"
      strokeWidth="2.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CHEVRON_SVG = ({
  direction,
  color = '#676770',
  size = '32',
  thickness = '2.66667',
}) => {
  const directions = {
    right: 0,
    left: 180,
    up: 270,
    down: 90,
  };

  const degree = directions[direction];

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: `rotate(${degree}deg)` }}
    >
      <path
        d="M12 24L20 16L12 8"
        stroke={color}
        strokeWidth={thickness}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const RADIO_UNCHECKED_SVG = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="15"
      height="15"
      rx="7.5"
      stroke="#9D9DA1"
    />
  </svg>
);

export const RADIO_CHECKED_SVG = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="16"
      height="16"
      rx="8"
      fill="#250473"
    />
    <circle
      cx="8"
      cy="8"
      r="6"
      fill="#250473"
      stroke="white"
    />
  </svg>
);

export const ARROW_LEFT_SVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 19.0703L11.5 17.5703L6.92969 13L21 13L21 11L6.92969 11L11.5 6.42969L10 4.92969L2.92969 12L10 19.0703Z"
      fill="black"
    />
  </svg>
);

export const REMOVE_SVG = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.99284 8.92304C8.3348 8.93132 8.60526 9.21346 8.59693 9.55323L7.97776 9.53825L7.35858 9.52325C7.36692 9.18349 7.65089 8.91477 7.99284 8.92304ZM7.97776 9.53825C7.35858 9.52325 7.35858 9.52325 7.35858 9.52325L7.35776 9.55824L7.35553 9.65769C7.35365 9.74413 7.35105 9.86958 7.34815 10.0261C7.34237 10.3389 7.33545 10.7762 7.33082 11.2738C7.32161 12.2662 7.32146 13.509 7.35885 14.4847C7.39975 15.5519 7.50985 16.9333 7.6007 17.9619C7.70331 19.1236 8.68529 19.9998 9.84946 19.9998H15.9503C17.1144 19.9998 18.0964 19.1236 18.1991 17.9619C18.2899 16.9333 18.4 15.5519 18.4409 14.4847C18.4783 13.509 18.4781 12.2662 18.4689 11.2738C18.4643 10.7762 18.4574 10.3389 18.4516 10.0261C18.4487 9.86958 18.4461 9.74413 18.4442 9.65769L18.442 9.55824L18.4412 9.5239C18.4328 9.18413 18.1488 8.91477 17.8069 8.92304C17.4649 8.93132 17.1945 9.21346 17.2028 9.55323L17.5974 9.54368C17.2028 9.55323 17.2028 9.55323 17.2028 9.55323L17.2036 9.58661L17.2058 9.6843C17.2076 9.76954 17.2103 9.89364 17.2131 10.0486C17.2188 10.3587 17.2257 10.792 17.2303 11.2851C17.2395 12.2739 17.2393 13.4927 17.2031 14.4379C17.1635 15.4727 17.0557 16.8284 16.9651 17.8543C16.9195 18.3711 16.4818 18.769 15.9503 18.769H9.84946C9.31794 18.769 8.88031 18.3711 8.83467 17.8543C8.74405 16.8284 8.63632 15.4727 8.59666 14.4379C8.56044 13.4927 8.56029 12.2739 8.56948 11.2851C8.57406 10.792 8.58093 10.3587 8.58665 10.0486C8.58952 9.89364 8.59209 9.76954 8.59395 9.6843L8.59613 9.58661L8.59693 9.55323L7.97776 9.53825Z"
      fill="#FFFFFF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.5 7.0773C6.5 6.73743 6.7773 6.46191 7.11935 6.46191H18.6806C19.0227 6.46191 19.3 6.73743 19.3 7.0773C19.3 7.41717 19.0227 7.69269 18.6806 7.69269H7.11935C6.7773 7.69269 6.5 7.41717 6.5 7.0773Z"
      fill="#FFFFFF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.90548 5.19457C10.3002 4.45929 11.0706 4 11.9093 4H13.8912C14.7299 4 15.5003 4.45929 15.895 5.19457L16.7499 6.78733C16.911 7.08722 16.7967 7.45998 16.495 7.61991C16.1931 7.77985 15.8179 7.6664 15.657 7.36652L14.802 5.77375C14.6226 5.43954 14.2724 5.23077 13.8912 5.23077H11.9093C11.5281 5.23077 11.1779 5.43954 10.9985 5.77375L10.1435 7.36652C9.98254 7.6664 9.60737 7.77985 9.30555 7.61991C9.00374 7.45998 8.88955 7.08722 9.05053 6.78733L9.90548 5.19457Z"
      fill="#FFFFFF"
    />
  </svg>
);

export const CALENDAR_SVG = ({ size = 24, color = '#C1BECF' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_5598_6322)">
      <path
        d="M3.62657 24H20.3732C22.1288 24 23.5555 22.5733 23.5555 20.8178V4.95998C23.5555 3.20442 22.1288 1.77774 20.3732 1.77774H19.111V0.888872C19.111 0.399978 18.711 0 18.2221 0C17.7332 0 17.3332 0.399978 17.3332 0.888872V1.77774H6.66659V0.888872C6.66659 0.399978 6.26654 0 5.77765 0C5.28875 0 4.88877 0.399978 4.88877 0.888872V1.77774H3.62657C1.87101 1.77774 0.444336 3.20442 0.444336 4.95998V20.8178C0.444336 22.5733 1.87101 24 3.62657 24ZM2.22216 4.95998C2.22216 4.18667 2.85326 3.55556 3.62657 3.55556H4.88877V4.44444C4.88877 4.93333 5.28875 5.33331 5.77765 5.33331C6.26654 5.33331 6.66652 4.93333 6.66652 4.44444V3.55556H17.3332V4.44444C17.3332 4.93333 17.7332 5.33331 18.2221 5.33331C18.711 5.33331 19.111 4.93333 19.111 4.44444V3.55556H20.3732C21.1465 3.55556 21.7776 4.18667 21.7776 4.95998V7.55556H2.22216V4.95998ZM2.22216 9.33331H21.7777V20.8178C21.7777 21.5911 21.1466 22.2222 20.3733 22.2222H3.62657C2.85326 22.2222 2.22216 21.5911 2.22216 20.8178V9.33331Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_5598_6322">
        <rect
          width="24"
          height="24"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);

export const LOCATION_SVG = ({ color = '#C1BECF' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2C8.134 2 5 5.134 5 9C5 14 12 22 12 22C12 22 19 14 19 9C19 5.134 15.866 2 12 2ZM12 11.5C10.619 11.5 9.5 10.381 9.5 9C9.5 7.619 10.619 6.5 12 6.5C13.381 6.5 14.5 7.619 14.5 9C14.5 10.381 13.381 11.5 12 11.5Z"
      fill={color}
    />
  </svg>
);

export const NOTES_SVG = ({ size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 3C2.9 3 2.00977 3.9 2.00977 5L2.00195 16.998C2.00195 18.103 2.89695 19 4.00195 19H6V23L10 19H20C21.1 19 22 18.1 22 17V5C22 3.9 21.1 3 20 3H4Z"
      fill="#C1BECF"
    />
  </svg>
);

export const CHECKMARK_SVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.9805 5.99067C19.7207 5.99841 19.4741 6.10699 19.293 6.2934L8.99999 16.5864L5.70702 13.2934C5.61488 13.1974 5.50451 13.1208 5.38238 13.068C5.26025 13.0152 5.12882 12.9874 4.99578 12.986C4.86274 12.9846 4.73076 13.0099 4.60759 13.0601C4.48441 13.1104 4.37251 13.1848 4.27843 13.2789C4.18435 13.3729 4.10999 13.4849 4.0597 13.608C4.00941 13.7312 3.9842 13.8632 3.98556 13.9962C3.98691 14.1293 4.0148 14.2607 4.06758 14.3828C4.12036 14.505 4.19699 14.6153 4.29296 14.7075L8.29296 18.7075C8.4805 18.8949 8.73482 19.0002 8.99999 19.0002C9.26516 19.0002 9.51948 18.8949 9.70702 18.7075L20.707 7.70747C20.8515 7.567 20.9502 7.38616 20.9902 7.18864C21.0301 6.99112 21.0095 6.78614 20.931 6.60055C20.8524 6.41497 20.7196 6.25744 20.55 6.14861C20.3804 6.03978 20.1819 5.98473 19.9805 5.99067Z"
      fill="#090A14"
    />
  </svg>
);

export const TEACHER_SVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 2C7.89453 2 7 2.89453 7 4C7 5.10547 7.89453 6 9 6C10.1055 6 11 5.10547 11 4C11 2.89453 10.1055 2 9 2ZM11.5938 6.1875C11.4414 6.1875 11.2773 6.21484 11.125 6.25V6.21875L10.9688 6.25L8.84375 6.625H8.75L8.6875 6.65625C8.19922 6.82031 7.71875 7.14453 7.375 7.65625L7.3125 7.71875L5.9375 10.2188H5.90625V10.25C5.71484 10.6328 5.30078 10.8281 4.8125 10.7188L3.0625 10.25L2.53125 12.1562L4.34375 12.6562L4.375 12.6875C5.67188 12.9766 7.03516 12.375 7.65625 11.1875H7.6875C7.69141 11.1797 7.68359 11.1641 7.6875 11.1562L8 10.5938V13.9062L6.40625 16.3125C6.00781 16.9141 5.98828 17.5859 6.1875 18.1875L7.8125 22H9.90625L8.3125 17.8125C8.21094 17.5117 8.20703 17.1992 8.40625 17L9.6875 15.0625L10 15V16.0938C10 16.9141 10.3125 17.6836 10.8125 18.3125L13.2188 21.3125L14.7812 20.0625L12.4062 17.0938L12.375 17.0625C12.0781 16.6914 12 16.4727 12 16.0938V8.65625L12.625 9.25H12.6562C13.6719 10.1211 15.1758 10.293 16.3438 9.5625L16.4062 9.5L17.5938 8.59375L16.4062 7L15.2812 7.84375C14.8594 8.10547 14.3477 8.05859 13.9688 7.75H13.9375L12.8125 6.6875C12.8008 6.67578 12.793 6.66406 12.7812 6.65625C12.4766 6.36719 12.0508 6.19141 11.5938 6.1875ZM18 11.1875V12.0625C17.9961 12.1055 17.9961 12.1445 18 12.1875V15.25C17.8398 15.2383 17.6797 15.2695 17.5 15.3125C16.6992 15.5117 16 16.207 16 16.9062C16 17.6055 16.6992 18.0117 17.5 17.8125C18.2344 17.6289 18.8633 17.0117 18.9688 16.375C18.9805 16.3438 18.9922 16.3125 19 16.2812C19 16.2617 19 16.2383 19 16.2188C19 16.207 19 16.1992 19 16.1875V13.125C20.6992 13.5547 21 15 21 15V14C21 12.6016 19.8984 11.1875 18 11.1875Z"
      fill="#C1BECF"
    />
  </svg>
);

export const RECURRING_SVG = ({ color = '#9D9DA1' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 3C9.26354 3 6.81516 4.23167 5.16602 6.16602L3 4V10H9L6.5918 7.5918C7.87479 6.0168 9.8149 5 12 5C15.859 5 19 8.14 19 12H21C21 7.038 16.963 3 12 3ZM3 12C3 16.963 7.037 21 12 21C14.7365 21 17.1848 19.7683 18.834 17.834L21 20V14H15L17.4082 16.4082C16.1252 17.9832 14.1851 19 12 19C8.141 19 5 15.859 5 12H3Z"
      fill={color}
    />
  </svg>
);

export const STUDENT_ADD_SVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 4C6.78906 4 5 5.78906 5 8C5 10.2109 6.78906 12 9 12C11.2109 12 13 10.2109 13 8C13 5.78906 11.2109 4 9 4ZM22.2812 6.8125L17.6875 11.5625L15.5938 9.5L14.1875 10.9062L17.7188 14.4375L18.4062 13.6875L23.7188 8.1875L22.2812 6.8125ZM9 14C2.89844 14 1 18 1 18V20H17V18C17 18 15.1016 14 9 14Z"
      fill="#C1BECF"
    />
  </svg>
);

export const TRASH_SVG = ({ size = 24, color = '#7E7B8F' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 2L9 3H3V5H21V3H15L14 2H10ZM4.36523 7L5.89258 20.2637C6.02458 21.2537 6.877 22 7.875 22H16.123C17.121 22 17.9744 21.2549 18.1074 20.2559L19.6348 7H4.36523Z"
      fill={color}
    />
  </svg>
);

export const PENCIL_SVG = ({ size = 24, color = '#7E7B8F' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.4141 2C18.1582 2 17.902 2.09747 17.707 2.29297L16 4L20 8L21.707 6.29297C22.098 5.90197 22.098 5.26891 21.707 4.87891L19.1211 2.29297C18.9256 2.09747 18.6699 2 18.4141 2ZM14.5 5.5L3 17V21H7L18.5 9.5L14.5 5.5Z"
      fill={color}
    />
  </svg>
);

export const MESSAGE_WITH_BADGE_SVG = ({ color = 'white', bg = '#CA3864' }) => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.66699 3C1.93366 3 1.34017 3.6 1.34017 4.33333L1.33496 12.332C1.33496 13.0687 1.93163 13.6667 2.66829 13.6667H4.00033V16.3333L6.66699 13.6667H13.3337C14.067 13.6667 14.667 13.0667 14.667 12.3333V4.33333C14.667 3.6 14.067 3 13.3337 3H2.66699Z"
      fill={color}
    />
    <rect
      x="9.5"
      y="0.5"
      width="7"
      height="7"
      rx="3.5"
      fill={color}
    />
    <rect
      x="9.5"
      y="0.5"
      width="7"
      height="7"
      rx="3.5"
      stroke={bg}
    />
  </svg>
);

export const KEBAB_SVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 3C11.4696 3 10.9609 3.21071 10.5858 3.58579C10.2107 3.96086 10 4.46957 10 5C10 5.53043 10.2107 6.03914 10.5858 6.41421C10.9609 6.78929 11.4696 7 12 7C12.5304 7 13.0391 6.78929 13.4142 6.41421C13.7893 6.03914 14 5.53043 14 5C14 4.46957 13.7893 3.96086 13.4142 3.58579C13.0391 3.21071 12.5304 3 12 3ZM12 10C11.4696 10 10.9609 10.2107 10.5858 10.5858C10.2107 10.9609 10 11.4696 10 12C10 12.5304 10.2107 13.0391 10.5858 13.4142C10.9609 13.7893 11.4696 14 12 14C12.5304 14 13.0391 13.7893 13.4142 13.4142C13.7893 13.0391 14 12.5304 14 12C14 11.4696 13.7893 10.9609 13.4142 10.5858C13.0391 10.2107 12.5304 10 12 10ZM12 17C11.4696 17 10.9609 17.2107 10.5858 17.5858C10.2107 17.9609 10 18.4696 10 19C10 19.5304 10.2107 20.0391 10.5858 20.4142C10.9609 20.7893 11.4696 21 12 21C12.5304 21 13.0391 20.7893 13.4142 20.4142C13.7893 20.0391 14 19.5304 14 19C14 18.4696 13.7893 17.9609 13.4142 17.5858C13.0391 17.2107 12.5304 17 12 17Z"
      fill="#9D9DA1"
    />
  </svg>
);

export const FAMILY_SVG = ({ size, color }) => (
  <svg
    width={size || 24}
    height={size || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 3C7.20435 3 6.44129 3.31607 5.87868 3.87868C5.31607 4.44129 5 5.20435 5 6C5 6.79565 5.31607 7.55871 5.87868 8.12132C6.44129 8.68393 7.20435 9 8 9C8.79565 9 9.55871 8.68393 10.1213 8.12132C10.6839 7.55871 11 6.79565 11 6C11 5.20435 10.6839 4.44129 10.1213 3.87868C9.55871 3.31607 8.79565 3 8 3ZM16 3C15.2044 3 14.4413 3.31607 13.8787 3.87868C13.3161 4.44129 13 5.20435 13 6C13 6.79565 13.3161 7.55871 13.8787 8.12132C14.4413 8.68393 15.2044 9 16 9C16.7956 9 17.5587 8.68393 18.1213 8.12132C18.6839 7.55871 19 6.79565 19 6C19 5.20435 18.6839 4.44129 18.1213 3.87868C17.5587 3.31607 16.7956 3 16 3ZM20.002 7.00195C20.002 7.00195 19.925 8.42105 20.752 9.24805C21.579 10.075 22.998 9.99805 22.998 9.99805C22.998 9.99805 23.075 8.57895 22.248 7.75195C21.421 6.92495 20.002 7.00195 20.002 7.00195ZM7 11C4.791 11 3 12.791 3 15V21H9C9 19.895 9.895 19 11 19H13C14.105 19 15 19.895 15 21H21V15C21 12.791 19.209 11 17 11H7ZM12 13C13.105 13 14 13.895 14 15C14 16.105 13.105 17 12 17C10.895 17 10 16.105 10 15C10 13.895 10.895 13 12 13Z"
      fill={color}
    />
  </svg>
);

export const FAMILY_SVG_PRIMARY = ({ size }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M8 3C7.20435 3 6.44129 3.31607 5.87868 3.87868C5.31607 4.44129 5 5.20435 5 6C5 6.79565 5.31607 7.55871 5.87868 8.12132C6.44129 8.68393 7.20435 9 8 9C8.79565 9 9.55871 8.68393 10.1213 8.12132C10.6839 7.55871 11 6.79565 11 6C11 5.20435 10.6839 4.44129 10.1213 3.87868C9.55871 3.31607 8.79565 3 8 3ZM16 3C15.2044 3 14.4413 3.31607 13.8787 3.87868C13.3161 4.44129 13 5.20435 13 6C13 6.79565 13.3161 7.55871 13.8787 8.12132C14.4413 8.68393 15.2044 9 16 9C16.7956 9 17.5587 8.68393 18.1213 8.12132C18.6839 7.55871 19 6.79565 19 6C19 5.20435 18.6839 4.44129 18.1213 3.87868C17.5587 3.31607 16.7956 3 16 3ZM20.002 7.00195C20.002 7.00195 19.925 8.42105 20.752 9.24805C21.579 10.075 22.998 9.99805 22.998 9.99805C22.998 9.99805 23.075 8.57895 22.248 7.75195C21.421 6.92495 20.002 7.00195 20.002 7.00195ZM7 11C4.791 11 3 12.791 3 15V21H9C9 19.895 9.895 19 11 19H13C14.105 19 15 19.895 15 21H21V15C21 12.791 19.209 11 17 11H7ZM12 13C13.105 13 14 13.895 14 15C14 16.105 13.105 17 12 17C10.895 17 10 16.105 10 15C10 13.895 10.895 13 12 13Z"
      fill="#BEBEE9"
    />
    <rect
      x="12"
      y="12"
      width="11"
      height="11"
      rx="5.5"
      fill="#12B76A"
    />
    <rect
      x="12"
      y="12"
      width="11"
      height="11"
      rx="5.5"
      stroke="#039855"
      strokeWidth="0.916667"
    />
    <g clipPath="url(#clip0_4881_62504)">
      <path
        d="M19.7916 17.2892V17.5C19.7913 17.9942 19.6313 18.475 19.3354 18.8708C19.0395 19.2666 18.6236 19.5562 18.1497 19.6963C17.6758 19.8364 17.1693 19.8196 16.7057 19.6484C16.2422 19.4771 15.8464 19.1606 15.5774 18.746C15.3085 18.3314 15.1807 17.841 15.2132 17.3479C15.2457 16.8548 15.4368 16.3854 15.7579 16.0098C16.0789 15.6341 16.5128 15.3723 16.9949 15.2634C17.4769 15.1545 17.9812 15.2043 18.4326 15.4054M19.7916 15.6667L17.4999 17.9606L16.8124 17.2731"
        stroke="white"
        strokeWidth="0.458333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4881_62504">
        <rect
          width="5.5"
          height="5.5"
          fill="white"
          transform="translate(14.75 14.75)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const PERSON_SVG = ({ size, color = '#C1BECF' }) => (
  <svg
    width={size || 24}
    height={size || 24}
    viewBox="0 0 22 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.9805 13.918H7.76172C4.57813 13.918 2 16.4961 2 19.6797C2 20.9609 3.03906 22 4.32031 22H17.4219C18.7031 22 19.7422 20.9609 19.7422 19.6797C19.7422 16.4961 17.1641 13.918 13.9805 13.918Z"
      fill={color}
    />
    <path
      d="M10.8711 12.2734C13.708 12.2734 16.0078 9.97365 16.0078 7.13672C16.0078 4.29979 13.708 2 10.8711 2C8.03416 2 5.73438 4.29979 5.73438 7.13672C5.73438 9.97365 8.03416 12.2734 10.8711 12.2734Z"
      fill={color}
    />
  </svg>
);

export const DANCER_SVG = ({ size, color }) => (
  <svg
    width={size || 24}
    height={size || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.5 2C4.854 2 2 6.9098 2 14.8418C2 18.5068 3.03439 20.4107 3.65039 21.2188C4.02739 21.7148 4.60628 22 5.23828 22H9.75977C10.3918 22 10.9717 21.7157 11.3477 21.2207C11.9657 20.4117 13 18.5068 13 14.8418C13 6.9098 10.146 2 7.5 2ZM16.5 2C15.32 2 14.0894 2.9793 13.1094 4.7793C13.5394 5.7193 13.8995 6.76016 14.1895 7.91016L19.3496 12.3301L18.9805 12.75C18.8405 12.91 18.6492 13 18.4492 13H14.9395C14.9795 13.61 15 14.2294 15 14.8594C15 18.2894 14.1794 20.4591 13.3594 21.7891C13.6294 21.9291 13.9302 22 14.2402 22H18.7598C19.3898 22 19.9696 21.7107 20.3496 21.2207C20.9596 20.4107 22 18.5098 22 14.8398C22 6.90984 19.15 2 16.5 2ZM7.5 4C7.84 4 8.50697 4.59717 9.16797 5.82617L4.46289 9.85742C5.26789 5.86042 6.896 4 7.5 4ZM16.5 4C17.1 4 18.7291 5.85938 19.5391 9.85938L14.8301 5.83008C15.4901 4.60008 16.16 4 16.5 4ZM9.98242 7.75977C10.3474 8.85277 10.6463 10.2125 10.8223 11.8145L9.98438 12.7461C9.83638 12.9091 9.64612 13 9.45312 13H5.54688C5.35387 13 5.16363 12.9081 5.01562 12.7441L4.64648 12.334L9.98242 7.75977Z"
      fill={color}
    />
  </svg>
);

export const STAR_SVG = ({ size = 22, color = '#FBB121' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.0054 1.69331e-05C10.8512 -0.00099641 10.6998 0.0434908 10.5684 0.128433C10.437 0.213375 10.3309 0.335373 10.262 0.480591L7.42815 6.44649L0.699099 7.53655C0.548479 7.56105 0.407248 7.62898 0.291069 7.73281C0.17489 7.83664 0.0883017 7.97232 0.0409079 8.12479C-0.00648589 8.27727 -0.0128336 8.44058 0.0225687 8.59662C0.057971 8.75266 0.13374 8.89532 0.241473 9.0088L4.89616 13.9084L3.85952 20.9994C3.83633 21.158 3.85536 21.3204 3.91449 21.4683C3.97363 21.6163 4.07056 21.7441 4.19453 21.8375C4.3185 21.931 4.46464 21.9865 4.61675 21.9978C4.76886 22.0092 4.92098 21.9759 5.05622 21.9018L11 18.6372L16.9438 21.9018C17.079 21.9759 17.2311 22.0092 17.3832 21.9978C17.5354 21.9865 17.6815 21.931 17.8055 21.8375C17.9294 21.7441 18.0264 21.6163 18.0855 21.4683C18.1446 21.3204 18.1637 21.158 18.1405 20.9994L17.1038 13.9084L21.7585 9.0088C21.8663 8.89532 21.942 8.75266 21.9774 8.59662C22.0128 8.44058 22.0065 8.27727 21.9591 8.12479C21.9117 7.97232 21.8251 7.83664 21.7089 7.73281C21.5928 7.62898 21.4515 7.56105 21.3009 7.53655L14.5719 6.44649L11.738 0.480591C11.6699 0.337092 11.5655 0.216231 11.4362 0.131406C11.3068 0.0465808 11.1577 0.0011041 11.0054 1.69331e-05Z"
      fill={color}
    />
  </svg>
);

export const HEART_SVG = ({ size = 31, color = '#D84B4B' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 31 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.68742 4.52051C5.77524 4.52051 2.58325 7.7125 2.58325 11.6247C2.58325 14.2701 4.57736 16.7609 7.00822 19.3154C9.43908 21.8699 12.4312 24.457 14.815 26.8409C14.9967 27.0225 15.243 27.1245 15.4999 27.1245C15.7568 27.1245 16.0032 27.0225 16.1849 26.8409C18.5687 24.457 21.5607 21.8699 23.9916 19.3154C26.4225 16.7609 28.4166 14.2701 28.4166 11.6247C28.4166 7.7125 25.2246 4.52051 21.3124 4.52051C19.0672 4.52051 17.1124 5.72595 15.4999 7.77364C13.8874 5.72595 11.9326 4.52051 9.68742 4.52051Z"
      fill={color}
    />
  </svg>
);

export const RECAP_SVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2ZM9 18H7V16H9V18ZM9 14H7V12H9V14ZM17 18H11V16H17V18ZM17 14H11V12H17V14ZM13 9V3.5L18.5 9H13Z"
      fill="#C1BECF"
    />
  </svg>
);

export const VIDEO_CIRCLE_SVG = () => (
  <svg
    width="44"
    height="44"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.9998 3.66675C11.8798 3.66675 3.6665 11.8801 3.6665 22.0001C3.6665 32.1201 11.8798 40.3334 21.9998 40.3334C32.1198 40.3334 40.3332 32.1201 40.3332 22.0001C40.3332 11.8801 32.1198 3.66675 21.9998 3.66675ZM26.8765 25.1717L24.5298 26.5284L22.1832 27.8851C19.1582 29.6267 16.6832 28.1967 16.6832 24.7134V22.0001V19.2867C16.6832 15.7851 19.1582 14.3734 22.1832 16.1151L24.5298 17.4717L26.8765 18.8284C29.9015 20.5701 29.9015 23.4301 26.8765 25.1717Z"
      fill="white"
    />
  </svg>
);

export const STYLE_SVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <mask
      id="mask0_2440_74257"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect
        width="24"
        height="24"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask0_2440_74257)">
      <path
        d="M21.7499 5.98524L16.4989 2.50158C15.9835 2.15951 15.2883 2.3 14.9462 2.81562C14.6041 3.33125 14.7448 4.02647 15.2604 4.36854L18.6143 6.59368L16.103 7.46682L14.6956 6.66871L8.46966 4.45263L3.75687 1.19859C3.24796 0.846949 2.55022 0.97468 2.19858 1.48376C1.84694 1.99301 1.97467 2.69074 2.48392 3.04221L7.32243 6.3832C7.40585 6.44077 7.49683 6.48676 7.59267 6.52L12.4595 8.20316L10.7411 10.9636L9.18805 8.76176C9.11033 8.65148 9.00896 8.56001 8.89146 8.49387L5.66881 6.68079C5.2319 6.43507 4.67851 6.58982 4.43278 7.02673C4.18689 7.46363 4.34181 8.01702 4.77872 8.26275L7.82278 9.97546C8.84245 11.4199 9.5751 12.4606 10.077 13.1734C10.3395 13.5461 10.6742 13.8621 11.0612 14.1028C12.0101 14.693 12.7117 15.1262 12.7897 15.1607L13.3496 18.3053L12.6143 21.9109C12.5143 22.402 12.8312 22.8814 13.3224 22.9816C13.8124 23.0814 14.2926 22.7659 14.393 22.2736L15.1629 18.4982C15.1857 18.3861 15.1871 18.2704 15.1671 18.1576L14.5279 14.5682L17.858 9.21897L21.4922 7.97892C22.3707 7.67915 22.5231 6.49834 21.7499 5.98524Z"
        fill="#C1BECF"
      />
      <path
        d="M11.5085 15.2326C10.5693 14.6478 9.3339 14.9353 8.74913 15.8744C8.16452 16.8137 8.45187 18.0491 9.39097 18.6337C10.3302 19.2185 11.5656 18.9311 12.1504 17.9918C12.735 17.0527 12.4476 15.8174 11.5085 15.2326Z"
        fill="#C1BECF"
      />
    </g>
  </svg>
);

export const LEVEL_SVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <mask
      id="mask0_2440_74251"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect
        width="24"
        height="24"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask0_2440_74251)">
      <path
        d="M4.9 20.4679H6.48333C7.52835 20.4679 8.38333 19.6129 8.38333 18.5679V12.9312C8.38333 11.8799 7.52835 11.0312 6.48333 11.0312H4.9C3.85499 11.0312 3 11.8799 3 12.9312V18.5679C3 19.6129 3.85499 20.4679 4.9 20.4679Z"
        fill="#C1BECF"
      />
      <path
        d="M13.2919 7.51562H11.7086C10.6636 7.51562 9.80859 8.37061 9.80859 9.41562V18.5673C9.80859 19.6123 10.6636 20.4673 11.7086 20.4673H13.2919C14.3369 20.4673 15.1919 19.6123 15.1919 18.5673V9.41562C15.1919 8.37061 14.3369 7.51562 13.2919 7.51562Z"
        fill="#C1BECF"
      />
      <path
        d="M20.0995 4H18.5162C17.4712 4 16.6162 4.85499 16.6162 5.9V18.5667C16.6162 19.6116 17.4712 20.4667 18.5162 20.4667H20.0995C21.1446 20.4667 21.9995 19.6116 21.9995 18.5667V5.9C21.9995 4.85499 21.1446 4 20.0995 4Z"
        fill="#C1BECF"
      />
    </g>
  </svg>
);

export const INFO_SVG = ({ color = '#250473' }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 1C3.24302 1 1 3.24302 1 6C1 8.75698 3.24302 11 6 11C8.75698 11 11 8.75698 11 6C11 3.24302 8.75698 1 6 1ZM6 1.75C8.35165 1.75 10.25 3.64835 10.25 6C10.25 8.35165 8.35165 10.25 6 10.25C3.64835 10.25 1.75 8.35165 1.75 6C1.75 3.64835 3.64835 1.75 6 1.75ZM6 3.5C5.86739 3.5 5.74021 3.55268 5.64645 3.64645C5.55268 3.74021 5.5 3.86739 5.5 4C5.5 4.13261 5.55268 4.25978 5.64645 4.35355C5.74021 4.44732 5.86739 4.5 6 4.5C6.13261 4.5 6.25978 4.44732 6.35355 4.35355C6.44732 4.25978 6.5 4.13261 6.5 4C6.5 3.86739 6.44732 3.74021 6.35355 3.64645C6.25978 3.55268 6.13261 3.5 6 3.5ZM5.99414 5.24463C5.89477 5.24618 5.80008 5.28711 5.73086 5.35843C5.66165 5.42975 5.62357 5.52563 5.625 5.625V8.375C5.6243 8.42469 5.63348 8.47403 5.65201 8.52014C5.67054 8.56625 5.69805 8.60822 5.73294 8.64361C5.76783 8.679 5.80941 8.7071 5.85525 8.72628C5.9011 8.74546 5.9503 8.75534 6 8.75534C6.0497 8.75534 6.0989 8.74546 6.14474 8.72628C6.19059 8.7071 6.23217 8.679 6.26706 8.64361C6.30195 8.60822 6.32946 8.56625 6.34799 8.52014C6.36652 8.47403 6.3757 8.42469 6.375 8.375V5.625C6.37572 5.57481 6.36636 5.52498 6.34747 5.47848C6.32857 5.43197 6.30054 5.38973 6.26502 5.35426C6.2295 5.31879 6.18723 5.29081 6.1407 5.27197C6.09417 5.25314 6.04433 5.24384 5.99414 5.24463Z"
      fill={color}
    />
  </svg>
);

export const CLASS_STYLE_SVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_5709_33711"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect
        width="24"
        height="24"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask0_5709_33711)">
      <path
        d="M21.7499 5.98524L16.4989 2.50158C15.9835 2.15951 15.2883 2.3 14.9462 2.81562C14.6041 3.33125 14.7448 4.02647 15.2604 4.36854L18.6143 6.59368L16.103 7.46682L14.6956 6.66871L8.46966 4.45263L3.75687 1.19859C3.24796 0.846949 2.55022 0.97468 2.19858 1.48376C1.84694 1.99301 1.97467 2.69074 2.48392 3.04221L7.32243 6.3832C7.40585 6.44077 7.49683 6.48676 7.59267 6.52L12.4595 8.20316L10.7411 10.9636L9.18805 8.76176C9.11033 8.65148 9.00896 8.56001 8.89146 8.49387L5.66881 6.68079C5.2319 6.43507 4.67851 6.58982 4.43278 7.02673C4.18689 7.46363 4.34181 8.01702 4.77872 8.26275L7.82278 9.97546C8.84245 11.4199 9.5751 12.4606 10.077 13.1734C10.3395 13.5461 10.6742 13.8621 11.0612 14.1028C12.0101 14.693 12.7117 15.1262 12.7897 15.1607L13.3496 18.3053L12.6143 21.9109C12.5143 22.402 12.8312 22.8814 13.3224 22.9816C13.8124 23.0814 14.2926 22.7659 14.393 22.2736L15.1629 18.4982C15.1857 18.3861 15.1871 18.2704 15.1671 18.1576L14.5279 14.5682L17.858 9.21897L21.4922 7.97892C22.3707 7.67915 22.5231 6.49834 21.7499 5.98524Z"
        fill="#BEBEE9"
      />
      <path
        d="M11.5083 15.2326C10.569 14.6478 9.33366 14.9353 8.74888 15.8744C8.16427 16.8137 8.45163 18.0491 9.39073 18.6337C10.33 19.2185 11.5653 18.9311 12.1501 17.9918C12.7347 17.0527 12.4474 15.8174 11.5083 15.2326Z"
        fill="#BEBEE9"
      />
    </g>
  </svg>
);

export const DIAGRAM_SVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_5709_33724"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect
        width="24"
        height="24"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask0_5709_33724)">
      <path
        d="M4.9 20.4679H6.48333C7.52835 20.4679 8.38333 19.6129 8.38333 18.5679V12.9312C8.38333 11.8799 7.52835 11.0312 6.48333 11.0312H4.9C3.85499 11.0312 3 11.8799 3 12.9312V18.5679C3 19.6129 3.85499 20.4679 4.9 20.4679Z"
        fill="#BEBEE9"
      />
      <path
        d="M13.2917 7.51562H11.7083C10.6633 7.51562 9.80835 8.37061 9.80835 9.41562V18.5673C9.80835 19.6123 10.6633 20.4673 11.7083 20.4673H13.2917C14.3367 20.4673 15.1917 19.6123 15.1917 18.5673V9.41562C15.1917 8.37061 14.3367 7.51562 13.2917 7.51562Z"
        fill="#BEBEE9"
      />
      <path
        d="M20.0998 4H18.5165C17.4714 4 16.6165 4.85499 16.6165 5.9V18.5667C16.6165 19.6116 17.4714 20.4667 18.5165 20.4667H20.0998C21.1448 20.4667 21.9998 19.6116 21.9998 18.5667V5.9C21.9998 4.85499 21.1448 4 20.0998 4Z"
        fill="#BEBEE9"
      />
    </g>
  </svg>
);
export const CLOCK_SVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2C6.48867 2 2 6.48867 2 12C2 17.5113 6.48867 22 12 22C14.2468 22 16.3284 21.2553 18 20L20 22V17H15L16.5625 18.5625C15.2683 19.4646 13.702 20 12 20C7.56933 20 4 16.4307 4 12C4 7.56933 7.56933 4 12 4C16.4307 4 20 7.56933 20 12H22C22 6.48867 17.5113 2 12 2ZM11 6V13H16V11H13V6H11Z"
      fill="white"
    />
  </svg>
);

export const REASON_SVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 0V3H13V0H11ZM4.22266 2.80859L2.80859 4.22266L4.92969 6.34375L6.34375 4.92969L4.22266 2.80859ZM19.7773 2.80859L17.6562 4.92969L19.0703 6.34375L21.1914 4.22266L19.7773 2.80859ZM12 5C8.14 5 5 8.14 5 12C5 14.785 6.639 17.1885 9 18.3145V21C9 22.103 9.897 23 11 23H13C14.103 23 15 22.103 15 21V18.3145C17.361 17.1885 19 14.785 19 12C19 8.14 15.86 5 12 5ZM0 11V13H3V11H0ZM21 11V13H24V11H21ZM4.92969 17.6562L2.80859 19.7773L4.22266 21.1914L6.34375 19.0703L4.92969 17.6562ZM19.0703 17.6562L17.6562 19.0703L19.7773 21.1914L21.1914 19.7773L19.0703 17.6562Z"
      fill="#C1BECF"
    />
  </svg>
);

export const COIN_SVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_5840_96614"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect
        width="24"
        height="24"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask0_5840_96614)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12ZM4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12ZM13 6C13 5.44772 12.5523 5 12 5C11.4477 5 11 5.44772 11 6V7C9.34315 7 8 8.34315 8 10C8 11.6569 9.34315 13 11 13H13C13.5523 13 14 13.4477 14 14C14 14.5523 13.5523 15 13 15H9.5C8.94772 15 8.5 15.4477 8.5 16C8.5 16.5523 8.94772 17 9.5 17H11V18C11 18.5523 11.4477 19 12 19C12.5523 19 13 18.5523 13 18V17C14.6569 17 16 15.6569 16 14C16 12.3431 14.6569 11 13 11H11C10.4477 11 10 10.5523 10 10C10 9.44772 10.4477 9 11 9H14.5C15.0523 9 15.5 8.55228 15.5 8C15.5 7.44772 15.0523 7 14.5 7H13V6Z"
        fill="#9D9DA1"
      />
    </g>
  </svg>
);
export const EXCLAMATION_SVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clipPath="url(#clip0_4580_38870)">
      <path
        d="M14.1406 0H5.85938C2.62344 0 0 2.62344 0 5.85938V14.1406C0 17.3766 2.62344 20 5.85938 20H14.1406C17.3766 20 20 17.3766 20 14.1406V5.85938C20 2.62344 17.3766 0 14.1406 0ZM11.3512 15.482C11.2738 15.6621 11.1695 15.818 11.0379 15.9496C10.9063 16.0812 10.752 16.1855 10.5746 16.2629C10.3973 16.3402 10.2086 16.3785 10.0082 16.3785C9.80781 16.3785 9.61055 16.3398 9.4332 16.2629C9.25586 16.1855 9.1 16.0812 8.96563 15.9496C8.83125 15.818 8.72539 15.6621 8.64805 15.482C8.5707 15.302 8.53203 15.1086 8.53203 14.9027C8.53203 14.6969 8.5707 14.5137 8.64805 14.3363C8.72539 14.159 8.83086 14.0047 8.96563 13.873C9.1 13.7414 9.25586 13.6371 9.4332 13.5598C9.61055 13.4824 9.80195 13.4438 10.0082 13.4438C10.2145 13.4438 10.3973 13.4824 10.5746 13.5598C10.752 13.6371 10.9063 13.7414 11.0379 13.873C11.1695 14.0047 11.2738 14.159 11.3512 14.3363C11.4285 14.5137 11.4672 14.7023 11.4672 14.9027C11.4672 15.1031 11.4285 15.3016 11.3512 15.482ZM10.9523 12.741H9.03906L8.51562 3.475H11.484L10.952 12.741H10.9523Z"
        fill="#250473"
      />
    </g>
    <defs>
      <clipPath id="clip0_4580_38870">
        <rect
          width="20"
          height="20"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);

export const ROUTINE_TYPE_SVG = ({ color = '#C1BECF' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 3C11.4696 3 10.9609 3.21071 10.5858 3.58579C10.2107 3.96086 10 4.46957 10 5C10 5.53043 10.2107 6.03914 10.5858 6.41421C10.9609 6.78929 11.4696 7 12 7C12.5304 7 13.0391 6.78929 13.4142 6.41421C13.7893 6.03914 14 5.53043 14 5C14 4.46957 13.7893 3.96086 13.4142 3.58579C13.0391 3.21071 12.5304 3 12 3ZM11.9844 8.98633C11.7195 8.99047 11.4671 9.09953 11.2825 9.28957C11.098 9.47962 10.9964 9.73512 11 10V11.5859L9.29297 13.293C9.19699 13.3851 9.12037 13.4955 9.06759 13.6176C9.0148 13.7397 8.98691 13.8712 8.98556 14.0042C8.98421 14.1373 9.00941 14.2692 9.0597 14.3924C9.10999 14.5156 9.18435 14.6275 9.27843 14.7216C9.37251 14.8156 9.48442 14.89 9.60759 14.9403C9.73077 14.9906 9.86274 15.0158 9.99579 15.0144C10.1288 15.0131 10.2603 14.9852 10.3824 14.9324C10.5045 14.8796 10.6149 14.803 10.707 14.707L12 13.4141L13.293 14.707C13.3851 14.803 13.4955 14.8796 13.6176 14.9324C13.7397 14.9852 13.8712 15.0131 14.0042 15.0144C14.1373 15.0158 14.2692 14.9906 14.3924 14.9403C14.5156 14.89 14.6275 14.8156 14.7216 14.7216C14.8156 14.6275 14.89 14.5156 14.9403 14.3924C14.9906 14.2692 15.0158 14.1373 15.0144 14.0042C15.0131 13.8712 14.9852 13.7397 14.9324 13.6176C14.8796 13.4955 14.803 13.3851 14.707 13.293L13 11.5859V10C13.0018 9.86621 12.9768 9.73341 12.9264 9.60947C12.876 9.48553 12.8012 9.37297 12.7065 9.27845C12.6118 9.18393 12.4991 9.10937 12.375 9.05919C12.251 9.00902 12.1182 8.98424 11.9844 8.98633ZM6 10C5.46957 10 4.96086 10.2107 4.58579 10.5858C4.21071 10.9609 4 11.4696 4 12C4 12.5304 4.21071 13.0391 4.58579 13.4142C4.96086 13.7893 5.46957 14 6 14C6.53043 14 7.03914 13.7893 7.41421 13.4142C7.78929 13.0391 8 12.5304 8 12C8 11.4696 7.78929 10.9609 7.41421 10.5858C7.03914 10.2107 6.53043 10 6 10ZM18 10C17.4696 10 16.9609 10.2107 16.5858 10.5858C16.2107 10.9609 16 11.4696 16 12C16 12.5304 16.2107 13.0391 16.5858 13.4142C16.9609 13.7893 17.4696 14 18 14C18.5304 14 19.0391 13.7893 19.4142 13.4142C19.7893 13.0391 20 12.5304 20 12C20 11.4696 19.7893 10.9609 19.4142 10.5858C19.0391 10.2107 18.5304 10 18 10ZM6 16C4.665 16 2 16.7208 2 18.0508V19C2 19.552 2.448 20 3 20H9C9.552 20 10 19.552 10 19V18.0508C10 16.7208 7.335 16 6 16ZM18 16C16.665 16 14 16.7208 14 18.0508V19C14 19.552 14.448 20 15 20H21C21.552 20 22 19.552 22 19V18.0508C22 16.7208 19.335 16 18 16Z"
      fill={color}
    />
  </svg>
);

export const ROUTINE_STATUS_SVG = ({ color = '#C1BECF' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 10.3955 21.611 8.88358 20.9365 7.53809L19.8145 8.66016C20.2545 9.68566 20.5 10.8145 20.5 12C20.5 16.687 16.687 20.5 12 20.5C7.313 20.5 3.5 16.687 3.5 12C3.5 7.313 7.313 3.5 12 3.5C14.223 3.5 16.2428 4.3646 17.7588 5.7666L18.8193 4.70605C17.0308 3.03255 14.6365 2 12 2ZM19.7353 5.49316C19.5406 5.49884 19.3556 5.5801 19.2197 5.71973L10.75 14.1895L8.78027 12.2197C8.71116 12.1477 8.62839 12.0903 8.53679 12.0507C8.4452 12.0111 8.34662 11.9902 8.24684 11.9892C8.14706 11.9882 8.04808 12.0071 7.9557 12.0448C7.86332 12.0825 7.77939 12.1383 7.70883 12.2088C7.63828 12.2794 7.5825 12.3633 7.54479 12.4557C7.50707 12.5481 7.48817 12.6471 7.48918 12.7468C7.49019 12.8466 7.51111 12.9452 7.5507 13.0368C7.59028 13.1284 7.64775 13.2112 7.71973 13.2803L10.2197 15.7803C10.3604 15.9209 10.5511 15.9999 10.75 15.9999C10.9489 15.9999 11.1396 15.9209 11.2803 15.7803L20.2803 6.78027C20.3885 6.6749 20.4623 6.53931 20.4922 6.39125C20.5221 6.2432 20.5065 6.08958 20.4477 5.9505C20.3888 5.81141 20.2893 5.69335 20.1622 5.61175C20.0351 5.53015 19.8863 5.48882 19.7353 5.49316Z"
      fill={color}
    />
  </svg>
);

export const EVENT_SVG = ({ color = '#C1BECF', size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 4C2.9 4 2 4.9 2 6V9.15039C2 9.56539 2.23786 9.97056 2.63086 10.1016C3.42486 10.3676 4 11.12 4 12C4 12.88 3.42486 13.6324 2.63086 13.8984C2.23786 14.0294 2 14.4346 2 14.8496V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V14.8496C22 14.4346 21.7621 14.0294 21.3691 13.8984C20.5751 13.6324 20 12.88 20 12C20 11.12 20.5751 10.3676 21.3691 10.1016C21.7621 9.97056 22 9.56539 22 9.15039V6C22 4.9 21.1 4 20 4H4ZM12 6.80078L13.4004 10.0996L17 10.4004L14.3008 12.8008L15.0996 16.1992L12 14.4004L8.90039 16.3008L9.69922 12.8008L7 10.4004L10.5996 10.0996L12 6.80078Z"
      fill={color}
    />
  </svg>
);

export const STATUS_SVG = ({ size = 24, color = '#C1BECF' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 10.3955 21.611 8.88358 20.9365 7.53809L19.8145 8.66016C20.2545 9.68566 20.5 10.8145 20.5 12C20.5 16.687 16.687 20.5 12 20.5C7.313 20.5 3.5 16.687 3.5 12C3.5 7.313 7.313 3.5 12 3.5C14.223 3.5 16.2428 4.3646 17.7588 5.7666L18.8193 4.70605C17.0308 3.03255 14.6365 2 12 2ZM19.7353 5.49316C19.5406 5.49884 19.3556 5.5801 19.2197 5.71973L10.75 14.1895L8.78027 12.2197C8.71116 12.1477 8.62839 12.0903 8.53679 12.0507C8.4452 12.0111 8.34662 11.9902 8.24684 11.9892C8.14706 11.9882 8.04808 12.0071 7.9557 12.0448C7.86332 12.0825 7.77939 12.1383 7.70883 12.2088C7.63828 12.2794 7.5825 12.3633 7.54479 12.4557C7.50707 12.5481 7.48817 12.6471 7.48918 12.7468C7.49019 12.8466 7.51111 12.9452 7.5507 13.0368C7.59028 13.1284 7.64775 13.2112 7.71973 13.2803L10.2197 15.7803C10.3604 15.9209 10.5511 15.9999 10.75 15.9999C10.9489 15.9999 11.1396 15.9209 11.2803 15.7803L20.2803 6.78027C20.3885 6.6749 20.4623 6.53931 20.4922 6.39125C20.5221 6.2432 20.5065 6.08958 20.4477 5.9505C20.3888 5.81141 20.2893 5.69335 20.1622 5.61175C20.0351 5.53015 19.8863 5.48882 19.7353 5.49316Z"
      fill={color}
    />
  </svg>
);

export const MUSIC_SVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 3C11.895 3 11 3.895 11 5V8V14.541C10.3924 14.1882 9.70261 14.0016 9 14C7.93913 14 6.92172 14.4214 6.17157 15.1716C5.42143 15.9217 5 16.9391 5 18C5 19.0609 5.42143 20.0783 6.17157 20.8284C6.92172 21.5786 7.93913 22 9 22C10.0609 22 11.0783 21.5786 11.8284 20.8284C12.5786 20.0783 13 19.0609 13 18V8H16.5C17.881 8 19 6.881 19 5.5C19 4.119 17.881 3 16.5 3H13Z"
      fill="#BEBEE9"
    />
  </svg>
);

export const DETAILS_SVG = ({ size = 24, color = '#BEBEE9' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M3.99805 3C2.89805 3 2.00781 3.9 2.00781 5L2 16.998C2 18.103 2.895 19 4 19H5.99805V23L9.99805 19H19.998C21.098 19 21.998 18.1 21.998 17V5C21.998 3.9 21.098 3 19.998 3H3.99805Z"
      fill={color}
    />
  </svg>
);

export const PLAY_BTN_SVG = ({ color = '#34079F', size = 28, onClick }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
  >
    <path
      d="M13.9998 0.666504C6.63984 0.666504 0.666504 6.63984 0.666504 13.9998C0.666504 21.3598 6.63984 27.3332 13.9998 27.3332C21.3598 27.3332 27.3332 21.3598 27.3332 13.9998C27.3332 6.63984 21.3598 0.666504 13.9998 0.666504ZM17.5465 16.3065L15.8398 17.2932L14.1332 18.2798C11.9332 19.5465 10.1332 18.5065 10.1332 15.9732V13.9998V12.0265C10.1332 9.47984 11.9332 8.45317 14.1332 9.71984L15.8398 10.7065L17.5465 11.6932C19.7465 12.9598 19.7465 15.0398 17.5465 16.3065Z"
      fill={color}
    />
  </svg>
);

export const PAUSE_BTN_SVG = ({ onClick }) => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
  >
    <path
      d="M13.9603 0.666504C6.60029 0.666504 0.626953 6.63984 0.626953 13.9998C0.626953 21.3598 6.60029 27.3332 13.9603 27.3332C21.3203 27.3332 27.2936 21.3598 27.2936 13.9998C27.2936 6.63984 21.3336 0.666504 13.9603 0.666504ZM12.2936 18.0398C12.2936 18.6798 12.027 18.9332 11.347 18.9332H9.61362C8.93362 18.9332 8.66695 18.6798 8.66695 18.0398V9.95984C8.66695 9.31984 8.93362 9.0665 9.61362 9.0665H11.3336C12.0136 9.0665 12.2803 9.31984 12.2803 9.95984V18.0398H12.2936ZM19.3336 18.0398C19.3336 18.6798 19.067 18.9332 18.387 18.9332H16.667C15.987 18.9332 15.7203 18.6798 15.7203 18.0398V9.95984C15.7203 9.31984 15.987 9.0665 16.667 9.0665H18.387C19.067 9.0665 19.3336 9.31984 19.3336 9.95984V18.0398Z"
      fill="#34079F"
    />
  </svg>
);

export const SEARCH_SVG = ({ color = '#090A14' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.9772 2C15.9326 2 19.9544 6.032 19.9544 11C19.9544 15.968 15.9326 20 10.9772 20C6.02178 20 2 15.968 2 11C2 6.032 6.02178 2 10.9772 2ZM10.9772 18C14.8344 18 17.9595 14.867 17.9595 11C17.9595 7.132 14.8344 4 10.9772 4C7.119 4 3.99493 7.132 3.99493 11C3.99493 14.867 7.119 18 10.9772 18ZM19.4407 18.071L22.2625 20.899L20.8511 22.314L18.0303 19.485L19.4407 18.071Z"
      fill={color}
    />
  </svg>
);

export const SCORE_SVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 3H5C3.895 3 3 3.895 3 5V19C3 20.105 3.895 21 5 21H19C20.105 21 21 20.105 21 19V5C21 3.895 20.105 3 19 3ZM15.22 17.391L12 15.45L8.781 17.391C8.403 17.619 7.938 17.28 8.038 16.851L8.89 13.19L6.053 10.733C5.72 10.445 5.898 9.897 6.337 9.859L10.08 9.539L11.541 6.084C11.713 5.678 12.287 5.678 12.459 6.084L13.919 9.53L17.662 9.85C18.101 9.888 18.279 10.435 17.946 10.724L15.11 13.18L15.963 16.851C16.063 17.28 15.597 17.619 15.22 17.391Z"
      fill="#BEBEE9"
    />
  </svg>
);

export const REQUEST_DOT_SVG = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="6"
      cy="6"
      r="5.5"
      stroke="#CA3864"
    />
  </svg>
);

export const GLOBE_SVG = () => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 0.5C6.74107 0.5 3.84869 2.07739 2.02148 4.5H2V4.52734C0.749953 6.19669 0 8.26038 0 10.5C0 16.011 4.489 20.5 10 20.5C15.511 20.5 20 16.011 20 10.5C20 4.989 15.511 0.5 10 0.5ZM13 3.08398C15.9351 4.26736 18 7.13265 18 10.5C18 12.5878 17.2006 14.4783 15.8984 15.9004C15.6426 15.0907 14.8946 14.5 14 14.5C13.448 14.5 13 14.052 13 13.5V11.5C13 10.948 12.552 10.5 12 10.5H8C7.448 10.5 7 10.052 7 9.5C7 8.948 7.448 8.5 8 8.5C8.552 8.5 9 8.052 9 7.5V6.5C9 5.948 9.448 5.5 10 5.5H11C12.105 5.5 13 4.605 13 3.5V3.08398ZM2.20703 8.70703L7 13.5V14.5C7 15.605 7.895 16.5 9 16.5V18.4316C5.04577 17.9412 2 14.5907 2 10.5C2 9.88219 2.07552 9.28403 2.20703 8.70703Z"
      fill="#7E7B8F"
    />
  </svg>
);

export const TRIANGLE_ERROR_SVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 16H12.008M12 9.99997V13M10.575 5.21697L3.51699 17C3.37157 17.252 3.29466 17.5377 3.29389 17.8287C3.29313 18.1197 3.36854 18.4058 3.51263 18.6586C3.65673 18.9114 3.86448 19.1221 4.11524 19.2697C4.366 19.4173 4.65103 19.4967 4.94199 19.5H19.058C19.3491 19.497 19.6343 19.4178 19.8852 19.2702C20.1362 19.1227 20.3441 18.912 20.4882 18.6591C20.6324 18.4062 20.7077 18.1199 20.7068 17.8288C20.7059 17.5377 20.6287 17.252 20.483 17L13.426 5.21697C13.2776 4.9719 13.0684 4.76925 12.8188 4.6286C12.5692 4.48796 12.2875 4.41406 12.001 4.41406C11.7145 4.41406 11.4328 4.48796 11.1832 4.6286C10.9336 4.76925 10.7244 4.9719 10.576 5.21697"
      stroke="#D84B4B"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ACCOUNT_APPLE_DISABLED_SVG = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.76555 6.13811C9.75463 6.04871 9.74916 5.95873 9.74916 5.86867C9.74916 5.18617 10.0455 4.45533 10.5719 3.85811C10.8349 3.55552 11.169 3.30394 11.5742 3.10339C11.9786 2.90589 12.3611 2.79644 12.7208 2.77783C12.731 2.87302 12.7359 2.96783 12.7355 3.06228C12.7354 3.77376 12.4769 4.437 11.9603 5.052C11.7297 5.32228 11.4811 5.55061 11.218 5.72728M15.4719 14.1226C15.2648 14.6053 15.0094 15.0658 14.7094 15.497C14.3086 16.0703 13.9803 16.467 13.7275 16.6873C13.3355 17.0486 12.9147 17.2343 12.4653 17.2445C12.1422 17.2445 11.7528 17.1526 11.2992 16.9656C10.8445 16.7797 10.4262 16.6869 10.0442 16.6873C9.64342 16.6869 9.21314 16.7797 8.75333 16.9656C8.29314 17.1523 7.92138 17.2502 7.63805 17.2595C7.20675 17.278 6.77647 17.0873 6.34722 16.6873C6.07314 16.4475 5.73083 16.0367 5.32027 15.4551C4.87953 14.8338 4.5174 14.1125 4.23388 13.2912C3.92981 12.4041 3.77777 11.5447 3.77777 10.7128C3.77777 9.76005 3.98333 8.93783 4.39444 8.24894C4.71759 7.69616 5.14814 7.25959 5.6861 6.93922C6.21396 6.62267 6.81648 6.45213 7.43194 6.44505C7.77472 6.44505 8.22416 6.55144 8.78249 6.76033C9.33944 6.96978 9.69694 7.07617 9.8536 7.07617C9.97083 7.07617 10.368 6.952 11.0414 6.70394C11.678 6.47431 12.2163 6.37857 12.6561 6.41672C13.8492 6.51311 14.7453 6.98478 15.3414 7.8345C14.2749 8.4832 13.7468 9.39024 13.7572 10.5556C13.7667 11.4628 14.095 12.2178 14.74 12.8173C15.025 13.0911 15.358 13.3101 15.7222 13.4634C15.6462 13.6858 15.5627 13.9057 15.4719 14.1226Z"
      stroke="#9D9DA1"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ACCOUNT_APPLE_ENABLED_SVG = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.7075 3.04102H12.7356V3.06213C12.7354 3.77361 12.4769 4.43685 11.9603 5.05185C11.3369 5.7824 10.5831 6.20463 9.76583 6.13796C9.75482 6.04857 9.74926 5.95859 9.74917 5.86852C9.74917 5.18602 10.0456 4.45518 10.5719 3.85796C10.8349 3.55537 11.169 3.30379 11.5742 3.10324C11.6186 3.08157 11.6631 3.06083 11.7075 3.04102ZM4.50806 8.57074C4.56083 8.46046 4.62278 8.35324 4.685 8.24907C5.00806 7.69574 5.57806 7.25935 6.11639 6.93907C6.65472 6.61879 6.76361 6.59796 7.38972 6.5874C7.7325 6.5874 8.16806 6.7674 8.72639 6.97629C9.28333 7.18574 9.69695 7.27629 9.85361 7.27629C9.97083 7.27629 10.3681 7.1924 11.0414 6.94463C11.6783 6.7149 12.2158 6.6099 12.6561 6.6474C13.8492 6.74407 14.3689 6.92935 14.965 7.77907C14.6086 7.99574 14.3856 8.28018 14.1494 8.55463L4.50806 8.57074Z"
      fill="#5C9E31"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.3295 5.98136C11.3295 5.98136 10.9489 6.22859 9.82335 6.40914C9.78335 6.41581 9.92613 6.0297 9.92613 6.0297L11.0392 5.7522"
      fill="#5C9E31"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.6289 8.0376C13.9922 8.57649 13.6675 9.19121 13.5342 9.97815L4.04333 9.91149C4.12528 9.27315 4.32972 8.87815 4.62806 8.37899C4.67583 8.29732 4.75889 8.13176 4.81139 8.05538L14.6289 8.0376Z"
      fill="#FCEA2B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.6658 9.48413C13.5997 9.74524 13.4869 10.0508 13.4897 10.3447C13.495 10.8564 13.5136 11.3191 13.7211 11.7336L4.1211 11.7405C4.04916 11.3236 4.02777 10.9416 4.02777 10.5377C4.02777 10.19 4.04249 9.81691 4.09722 9.50441L13.6658 9.48413Z"
      fill="#F4AA41"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.7167 11.73C13.8731 12.2158 14.157 12.5472 14.5539 12.9161C14.8464 13.1939 15.0156 13.4436 15.3789 13.5964C15.377 13.6019 15.377 13.6114 15.3753 13.6166L4.62585 13.6125C4.60307 13.5503 4.43363 13.0664 4.41196 13.003C4.20696 12.405 4.18779 12.308 4.12085 11.7353L13.7167 11.73Z"
      fill="#EA5A47"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.4622 15.5477C14.7278 15.1504 14.9562 14.7295 15.1445 14.2902C15.2328 14.0794 15.3617 13.8599 15.4406 13.631C15.6892 13.7355 15.6425 13.7205 15.3795 13.6033L4.6239 13.6108C4.88779 14.3402 5.32029 14.9919 5.71168 15.5591L14.4622 15.5477Z"
      fill="#8967AA"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.37775 16.9985C7.07248 16.9249 6.88109 16.819 6.57692 16.5354C6.31914 16.3099 6.07664 16.074 5.69775 15.5451L14.4861 15.5312C14.1039 16.0729 14.0039 16.244 13.7597 16.4568C13.4375 16.754 13.1164 16.9199 12.7553 16.9799L12.3297 17.0076C12.0714 16.9701 11.7658 16.901 11.4408 16.7671C10.9861 16.581 10.435 16.4754 10.0525 16.4754C9.65164 16.4754 9.23525 16.5068 8.77525 16.6929C8.46414 16.8193 7.99192 16.9901 7.76164 17.0354L7.37775 16.9985Z"
      fill="#61B2E4"
    />
    <path
      d="M9.76555 6.13811C9.75463 6.04871 9.74916 5.95873 9.74916 5.86867C9.74916 5.18617 10.0455 4.45533 10.5719 3.85811C10.8349 3.55552 11.169 3.30394 11.5742 3.10339C11.9786 2.90589 12.3611 2.79644 12.7208 2.77783C12.731 2.87302 12.7359 2.96783 12.7355 3.06228C12.7354 3.77376 12.4769 4.437 11.9603 5.052C11.7297 5.32228 11.4811 5.55061 11.218 5.72728M15.4719 14.1226C15.2648 14.6053 15.0094 15.0658 14.7094 15.497C14.3086 16.0703 13.9803 16.467 13.7275 16.6873C13.3355 17.0486 12.9147 17.2343 12.4653 17.2445C12.1422 17.2445 11.7528 17.1526 11.2992 16.9656C10.8445 16.7797 10.4262 16.6869 10.0442 16.6873C9.64342 16.6869 9.21314 16.7797 8.75333 16.9656C8.29314 17.1523 7.92138 17.2502 7.63805 17.2595C7.20675 17.278 6.77647 17.0873 6.34722 16.6873C6.07314 16.4475 5.73083 16.0367 5.32027 15.4551C4.87953 14.8338 4.5174 14.1125 4.23388 13.2912C3.92981 12.4041 3.77777 11.5447 3.77777 10.7128C3.77777 9.76005 3.98333 8.93783 4.39444 8.24894C4.71759 7.69616 5.14814 7.25959 5.6861 6.93922C6.21396 6.62267 6.81648 6.45213 7.43194 6.44505C7.77472 6.44505 8.22416 6.55144 8.78249 6.76033C9.33944 6.96978 9.69694 7.07617 9.8536 7.07617C9.97083 7.07617 10.368 6.952 11.0414 6.70394C11.678 6.47431 12.2163 6.37857 12.6561 6.41672C13.8492 6.51311 14.7453 6.98478 15.3414 7.8345C14.2749 8.4832 13.7468 9.39024 13.7572 10.5556C13.7667 11.4628 14.095 12.2178 14.74 12.8173C15.025 13.0911 15.358 13.3101 15.7222 13.4634C15.6462 13.6858 15.5627 13.9057 15.4719 14.1226Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ACCOUNT_GOOGLE_DISABLED_SVG = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_8071_41291)">
      <path
        d="M4.87704 0.460421C3.47822 0.945683 2.27188 1.86673 1.43522 3.08827C0.598551 4.30981 0.175656 5.76745 0.228649 7.2471C0.281642 8.72675 0.807731 10.1504 1.72964 11.309C2.65155 12.4675 3.92069 13.2999 5.35063 13.6839C6.50992 13.983 7.72452 13.9961 8.89001 13.7221C9.94583 13.485 10.922 12.9777 11.7228 12.25C12.5563 11.4694 13.1614 10.4764 13.4728 9.37776C13.8114 8.18303 13.8716 6.9266 13.6489 5.70495H7.13892V8.40542H10.9091C10.8337 8.83613 10.6723 9.2472 10.4343 9.61405C10.1964 9.9809 9.88692 10.296 9.52438 10.5404C9.064 10.845 8.54504 11.0499 8.00079 11.142C7.45495 11.2435 6.89507 11.2435 6.34923 11.142C5.796 11.0276 5.27265 10.7993 4.81251 10.4715C4.0733 9.94825 3.51825 9.20487 3.22657 8.34745C2.92996 7.47398 2.92996 6.52702 3.22657 5.65355C3.43419 5.04128 3.77742 4.48382 4.23063 4.02276C4.74928 3.48546 5.4059 3.10139 6.12846 2.91269C6.85102 2.724 7.61159 2.73797 8.32673 2.95308C8.88538 3.12457 9.39625 3.4242 9.8186 3.82808C10.2437 3.40516 10.6681 2.98115 11.0917 2.55605C11.3105 2.32745 11.5489 2.1098 11.7644 1.87573C11.1197 1.27579 10.3629 0.808952 9.53751 0.501983C8.03437 -0.043809 6.38967 -0.0584766 4.87704 0.460421Z"
        fill="#9D9DA1"
      />
    </g>
    <defs>
      <clipPath id="clip0_8071_41291">
        <rect
          width="15"
          height="15"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);

export const ACCOUNT_GOOGLE_ENABLED_SVG = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_8068_41275)">
      <path
        d="M4.87701 0.460543C3.47819 0.945805 2.27185 1.86685 1.43519 3.08839C0.598521 4.30993 0.175626 5.76758 0.228619 7.24722C0.281612 8.72687 0.8077 10.1505 1.72961 11.3091C2.65152 12.4676 3.92066 13.3 5.3506 13.684C6.50989 13.9831 7.72449 13.9963 8.88998 13.7223C9.9458 13.4851 10.9219 12.9778 11.7228 12.2501C12.5563 11.4695 13.1613 10.4765 13.4728 9.37789C13.8113 8.18315 13.8716 6.92672 13.6489 5.70507H7.13888V8.40554H10.909C10.8337 8.83625 10.6722 9.24733 10.4343 9.61417C10.1964 9.98102 9.88689 10.2961 9.52435 10.5405C9.06397 10.8451 8.545 11.05 8.00076 11.1421C7.45492 11.2436 6.89504 11.2436 6.3492 11.1421C5.79597 11.0277 5.27262 10.7994 4.81248 10.4716C4.07327 9.94837 3.51822 9.20499 3.22654 8.34757C2.92993 7.4741 2.92993 6.52714 3.22654 5.65367C3.43416 5.0414 3.77739 4.48394 4.2306 4.02289C4.74925 3.48558 5.40587 3.10151 6.12843 2.91281C6.85099 2.72412 7.61156 2.73809 8.3267 2.9532C8.88535 3.12469 9.39622 3.42432 9.81857 3.8282C10.2437 3.40528 10.6681 2.98127 11.0917 2.55617C11.3104 2.32757 11.5489 2.10992 11.7644 1.87586C11.1197 1.27591 10.3629 0.809074 9.53748 0.502106C8.03434 -0.0436869 6.38964 -0.0583545 4.87701 0.460543Z"
        fill="white"
      />
      <path
        d="M4.87704 0.460586C6.38954 -0.058664 8.03424 -0.0443824 9.5375 0.501055C10.3631 0.810109 11.1195 1.27919 11.7633 1.88137C11.5445 2.11543 11.3138 2.33418 11.0906 2.56168C10.6663 2.98533 10.2422 3.40751 9.8186 3.82824C9.39624 3.42436 8.88538 3.12473 8.32672 2.95324C7.61182 2.73738 6.85127 2.7226 6.12853 2.91052C5.40578 3.09845 4.74875 3.48181 4.22954 4.01856C3.77632 4.47961 3.4331 5.03707 3.22547 5.64934L0.95813 3.89387C1.7697 2.28448 3.17489 1.05342 4.87704 0.460586Z"
        fill="#E33629"
      />
      <path
        d="M0.356569 5.63286C0.478436 5.02889 0.680761 4.44398 0.958132 3.8938L3.22548 5.65364C2.92887 6.52712 2.92887 7.47407 3.22548 8.34755C2.47006 8.93088 1.71428 9.51713 0.958132 10.1063C0.263765 8.72414 0.0519955 7.14935 0.356569 5.63286Z"
        fill="#F8BD00"
      />
      <path
        d="M7.13891 5.70386H13.6489C13.8716 6.9255 13.8114 8.18193 13.4728 9.37667C13.1614 10.4753 12.5563 11.4683 11.7228 12.2489C10.9911 11.6779 10.2561 11.1114 9.52438 10.5404C9.88715 10.2957 10.1968 9.9803 10.4347 9.61306C10.6727 9.24583 10.834 8.83433 10.9091 8.40323H7.13891C7.13782 7.50417 7.13891 6.60401 7.13891 5.70386Z"
        fill="#587DBD"
      />
      <path
        d="M0.957031 10.1062C1.71318 9.52283 2.46896 8.93658 3.22438 8.34741C3.51663 9.20513 4.07247 9.94855 4.8125 10.4715C5.27407 10.7977 5.79855 11.0242 6.3525 11.1365C6.89834 11.238 7.45822 11.238 8.00406 11.1365C8.54831 11.0444 9.06728 10.8394 9.52766 10.5349C10.2594 11.1058 10.9944 11.6724 11.7261 12.2434C10.9253 12.9715 9.94921 13.4792 8.89328 13.7166C7.72779 13.9906 6.5132 13.9775 5.35391 13.6783C4.43702 13.4335 3.58058 13.002 2.83828 12.4107C2.0526 11.7869 1.41089 11.0008 0.957031 10.1062Z"
        fill="#319F43"
      />
    </g>
    <defs>
      <clipPath id="clip0_8068_41275">
        <rect
          width="14"
          height="14"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);

export const SUCCESS_SVG = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 0C4.486 0 0 4.486 0 10C0 15.514 4.486 20 10 20C15.514 20 20 15.514 20 10C20 8.3955 19.611 6.88358 18.9365 5.53809L17.8145 6.66016C18.2545 7.68566 18.5 8.8145 18.5 10C18.5 14.687 14.687 18.5 10 18.5C5.313 18.5 1.5 14.687 1.5 10C1.5 5.313 5.313 1.5 10 1.5C12.223 1.5 14.2428 2.3646 15.7588 3.7666L16.8193 2.70605C15.0308 1.03255 12.6365 0 10 0ZM17.7353 3.49316C17.5406 3.49884 17.3556 3.5801 17.2197 3.71973L8.75 12.1895L6.78027 10.2197C6.71116 10.1477 6.62839 10.0903 6.53679 10.0507C6.4452 10.0111 6.34662 9.99019 6.24684 9.98918C6.14706 9.98816 6.04808 10.0071 5.9557 10.0448C5.86332 10.0825 5.77939 10.1383 5.70883 10.2088C5.63828 10.2794 5.5825 10.3633 5.54479 10.4557C5.50707 10.5481 5.48817 10.6471 5.48918 10.7468C5.49019 10.8466 5.51111 10.9452 5.5507 11.0368C5.59028 11.1284 5.64775 11.2112 5.71973 11.2803L8.21973 13.7803C8.36038 13.9209 8.55112 13.9999 8.75 13.9999C8.94888 13.9999 9.13962 13.9209 9.28027 13.7803L18.2803 4.78027C18.3885 4.6749 18.4623 4.53931 18.4922 4.39125C18.5221 4.2432 18.5065 4.08958 18.4477 3.9505C18.3888 3.81141 18.2893 3.69335 18.1622 3.61175C18.0351 3.53015 17.8863 3.48882 17.7353 3.49316Z"
      fill="#42CD47"
    />
  </svg>
);

export const ERROR_SVG = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.99998 0C15.522 0 20 4.47797 20 9.99998C20 15.522 15.522 20 9.99998 20C4.47797 20 0 15.522 0 9.99998C0 4.47797 4.47797 0 9.99998 0ZM9.99998 2.00001C5.58904 2.00001 2.00001 5.589 2.00001 9.99998C2.00001 14.411 5.589 18 9.99998 18C14.411 18 18 14.411 18 9.99998C18 5.589 14.411 2.00001 9.99998 2.00001ZM12.293 6.29301L13.707 7.70699L11.414 9.99998L13.707 12.293L12.293 13.707L9.99998 11.414L7.70699 13.707L6.29301 12.293L8.58599 9.99998L6.29301 7.70699L7.70699 6.29301L9.99998 8.58599L12.293 6.29301Z"
      fill="#D84B4B"
    />
  </svg>
);

export const INVOICES_SVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 2C19 2.552 18.552 3 18 3C17.448 3 17 2.552 17 2H15C15 2.552 14.552 3 14 3C13.448 3 13 2.552 13 2H11C11 2.552 10.552 3 10 3C9.448 3 9 2.552 9 2H7C7 2.552 6.552 3 6 3C5.448 3 5 2.552 5 2H4C3.448 2 3 2.448 3 3V20C3 21.105 3.895 22 5 22H19C20.105 22 21 21.105 21 20V3C21 2.448 20.552 2 20 2H19ZM13 18H7C6.448 18 6 17.552 6 17C6 16.448 6.448 16 7 16H13C13.552 16 14 16.448 14 17C14 17.552 13.552 18 13 18ZM13 14H7C6.448 14 6 13.552 6 13C6 12.448 6.448 12 7 12H13C13.552 12 14 12.448 14 13C14 13.552 13.552 14 13 14ZM17.5 18H16.5C16.224 18 16 17.776 16 17.5V16.5C16 16.224 16.224 16 16.5 16H17.5C17.776 16 18 16.224 18 16.5V17.5C18 17.776 17.776 18 17.5 18ZM17.5 14H16.5C16.224 14 16 13.776 16 13.5V12.5C16 12.224 16.224 12 16.5 12H17.5C17.776 12 18 12.224 18 12.5V13.5C18 13.776 17.776 14 17.5 14ZM17 9H7C6.448 9 6 8.552 6 8C6 7.448 6.448 7 7 7H17C17.552 7 18 7.448 18 8C18 8.552 17.552 9 17 9Z"
      fill="#250473"
    />
  </svg>
);

export const LINK_SVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 7C3.239 7 1 9.239 1 12C1 14.761 3.239 17 6 17H10V15H6C4.343 15 3 13.657 3 12C3 10.343 4.343 9 6 9H10V7H6ZM14 7V9H18C19.657 9 21 10.343 21 12C21 13.657 19.657 15 18 15H14V17H18C20.761 17 23 14.761 23 12C23 9.239 20.761 7 18 7H14ZM7 11V13H17V11H7Z"
      fill="#1B0354"
    />
  </svg>
);

export const TEAM_SVG = ({ color, size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 3C11.4696 3 10.9609 3.21071 10.5858 3.58579C10.2107 3.96086 10 4.46957 10 5C10 5.53043 10.2107 6.03914 10.5858 6.41421C10.9609 6.78929 11.4696 7 12 7C12.5304 7 13.0391 6.78929 13.4142 6.41421C13.7893 6.03914 14 5.53043 14 5C14 4.46957 13.7893 3.96086 13.4142 3.58579C13.0391 3.21071 12.5304 3 12 3ZM11.9844 8.98633C11.7195 8.99047 11.4671 9.09953 11.2825 9.28957C11.098 9.47962 10.9964 9.73512 11 10V11.5859L9.29297 13.293C9.19699 13.3851 9.12037 13.4955 9.06759 13.6176C9.0148 13.7397 8.98691 13.8712 8.98556 14.0042C8.98421 14.1373 9.00941 14.2692 9.0597 14.3924C9.10999 14.5156 9.18435 14.6275 9.27843 14.7216C9.37251 14.8156 9.48442 14.89 9.60759 14.9403C9.73077 14.9906 9.86274 15.0158 9.99579 15.0144C10.1288 15.0131 10.2603 14.9852 10.3824 14.9324C10.5045 14.8796 10.6149 14.803 10.707 14.707L12 13.4141L13.293 14.707C13.3851 14.803 13.4955 14.8796 13.6176 14.9324C13.7397 14.9852 13.8712 15.0131 14.0042 15.0144C14.1373 15.0158 14.2692 14.9906 14.3924 14.9403C14.5156 14.89 14.6275 14.8156 14.7216 14.7216C14.8156 14.6275 14.89 14.5156 14.9403 14.3924C14.9906 14.2692 15.0158 14.1373 15.0144 14.0042C15.0131 13.8712 14.9852 13.7397 14.9324 13.6176C14.8796 13.4955 14.803 13.3851 14.707 13.293L13 11.5859V10C13.0018 9.86621 12.9768 9.73341 12.9264 9.60947C12.876 9.48553 12.8012 9.37297 12.7065 9.27845C12.6118 9.18393 12.4991 9.10937 12.375 9.05919C12.251 9.00902 12.1182 8.98424 11.9844 8.98633ZM6 10C5.46957 10 4.96086 10.2107 4.58579 10.5858C4.21071 10.9609 4 11.4696 4 12C4 12.5304 4.21071 13.0391 4.58579 13.4142C4.96086 13.7893 5.46957 14 6 14C6.53043 14 7.03914 13.7893 7.41421 13.4142C7.78929 13.0391 8 12.5304 8 12C8 11.4696 7.78929 10.9609 7.41421 10.5858C7.03914 10.2107 6.53043 10 6 10ZM18 10C17.4696 10 16.9609 10.2107 16.5858 10.5858C16.2107 10.9609 16 11.4696 16 12C16 12.5304 16.2107 13.0391 16.5858 13.4142C16.9609 13.7893 17.4696 14 18 14C18.5304 14 19.0391 13.7893 19.4142 13.4142C19.7893 13.0391 20 12.5304 20 12C20 11.4696 19.7893 10.9609 19.4142 10.5858C19.0391 10.2107 18.5304 10 18 10ZM6 16C4.665 16 2 16.7208 2 18.0508V19C2 19.552 2.448 20 3 20H9C9.552 20 10 19.552 10 19V18.0508C10 16.7208 7.335 16 6 16ZM18 16C16.665 16 14 16.7208 14 18.0508V19C14 19.552 14.448 20 15 20H21C21.552 20 22 19.552 22 19V18.0508C22 16.7208 19.335 16 18 16Z"
      fill={color}
    />
  </svg>
);

export const CLOSE_SVG = ({ color, size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.65291 10.7731L1.75787 10.6875L6.00007 6.44529L10.2423 10.6875L10.3472 10.7731C10.606 10.9439 10.9577 10.9153 11.1855 10.6875C11.4133 10.4597 11.442 10.1079 11.2712 9.84918L11.1855 9.74422L6.94334 5.50202L11.1857 1.25963C11.4461 0.999276 11.4461 0.576706 11.1857 0.316356C10.9254 0.0560064 10.5028 0.0560063 10.2425 0.316356L6.00007 4.55875L1.75767 0.316356C1.49732 0.0560064 1.07475 0.0560064 0.814403 0.316356C0.554053 0.576705 0.554053 0.999276 0.814403 1.25963L5.0568 5.50202L0.814602 9.74422L0.728976 9.84918C0.558147 10.1079 0.586806 10.4597 0.814602 10.6875C1.0424 10.9153 1.39415 10.9439 1.65291 10.7731Z"
      fill={color}
    />
  </svg>
);

export const COPY_SVG = ({ size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ cursor: 'pointer' }}
  >
    <path
      d="M5 7.667C5 6.95967 5.28099 6.28131 5.78115 5.78115C6.28131 5.28099 6.95967 5 7.667 5H16.333C16.6832 5 17.03 5.06898 17.3536 5.20301C17.6772 5.33704 17.9712 5.53349 18.2189 5.78115C18.4665 6.0288 18.663 6.32281 18.797 6.64638C18.931 6.96996 19 7.31676 19 7.667V16.333C19 16.6832 18.931 17.03 18.797 17.3536C18.663 17.6772 18.4665 17.9712 18.2189 18.2189C17.9712 18.4665 17.6772 18.663 17.3536 18.797C17.03 18.931 16.6832 19 16.333 19H7.667C7.31676 19 6.96996 18.931 6.64638 18.797C6.32281 18.663 6.0288 18.4665 5.78115 18.2189C5.53349 17.9712 5.33704 17.6772 5.20301 17.3536C5.06898 17.03 5 16.6832 5 16.333V7.667Z"
      stroke="#250473"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.012 14.737C1.705 14.5626 1.44965 14.31 1.2719 14.0049C1.09415 13.6998 1.00034 13.3531 1 13V3C1 1.9 1.9 1 3 1H13C13.75 1 14.158 1.385 14.5 2"
      stroke="#250473"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
